import type {Vsop87Element, Vsop87Group} from '@app/types/Vsop87Types';

const VSOP87_L0: Vsop87Element = [
    [1.75347045673],
    [0.03341656453, 4.66925680415, 6283.0758499914],
    [0.00034894275, 4.62610242189, 12566.1516999828],
    [0.00003417572, 2.82886579754, 3.523118349],
    [0.00003497056, 2.74411783405, 5753.3848848968],
    [0.00003135899, 3.62767041756, 77713.7714681205],
    [0.00002676218, 4.41808345438, 7860.4193924392],
    [0.00002342691, 6.13516214446, 3930.2096962196],
    [0.00001273165, 2.03709657878, 529.6909650946],
    [0.00001324294, 0.74246341673, 11506.7697697936],
    [0.00000901854, 2.04505446477, 26.2983197998],
    [0.00001199167, 1.10962946234, 1577.3435424478],
    [0.00000857223, 3.50849152283, 398.1490034082],
    [0.00000779786, 1.17882681962, 5223.6939198022],
    [0.0000099025, 5.23268072088, 5884.9268465832],
    [0.00000753141, 2.53339052847, 5507.5532386674],
    [0.00000505267, 4.58292599973, 18849.2275499742],
    [0.00000492392, 4.20505711826, 775.522611324],
    [0.00000356672, 2.91954114478, 0.0673103028],
    [0.00000284125, 1.89869240932, 796.2980068164],
    [0.00000242879, 0.34481445893, 5486.777843175],
    [0.00000317087, 5.84901948512, 11790.6290886588],
    [0.00000271112, 0.31486255375, 10977.078804699],
    [0.00000206217, 4.80646631478, 2544.3144198834],
    [0.00000205478, 1.86953770281, 5573.1428014331],
    [0.00000202318, 2.45767790232, 6069.7767545534],
    [0.00000126225, 1.08295459501, 20.7753954924],
    [0.00000155516, 0.83306084617, 213.299095438],
    [0.00000115132, 0.64544911683, 0.9803210682],
    [0.00000102851, 0.63599845579, 4694.0029547076],
    [0.00000101724, 4.2667980198, 7.1135470008],
    [0.00000099206, 6.20992926918, 2146.1654164752],
    [0.00000132212, 3.41118292683, 2942.4634232916],
    [0.00000097607, 0.68101342359, 155.4203994342],
    [0.00000085128, 1.29870764804, 6275.9623029906],
    [0.00000074651, 1.755089133, 5088.6288397668],
    [0.00000101895, 0.97569280312, 15720.8387848784],
    [0.00000084711, 3.67080093031, 71430.69561812909],
    [0.00000073547, 4.67926633877, 801.8209311238],
    [0.00000073874, 3.50319414955, 3154.6870848956],
    [0.00000078757, 3.03697458703, 12036.4607348882],
    [0.00000079637, 1.80791287082, 17260.1546546904],
    [0.00000085803, 5.9832263126, 161000.6857376741],
    [0.00000056963, 2.78430458592, 6286.5989683404],
    [0.00000061148, 1.81839892984, 7084.8967811152],
    [0.00000069627, 0.83297621398, 9437.762934887],
    [0.00000056116, 4.38694865354, 14143.4952424306],
    [0.00000062449, 3.97763912806, 8827.3902698748],
    [0.00000051145, 0.28306832879, 5856.4776591154],
    [0.00000055577, 3.47006059924, 6279.5527316424],
    [0.00000041036, 5.36817592855, 8429.2412664666],
    [0.00000051605, 1.33282739866, 1748.016413067],
    [0.00000051992, 0.18914947184, 12139.5535091068],
    [0.00000049, 0.48735014197, 1194.4470102246],
    [0.000000392, 6.16833020996, 10447.3878396044],
    [0.0000003557, 1.775968892, 6812.766815086],
    [0.0000003677, 6.04133863162, 10213.285546211],
    [0.00000036596, 2.56957481827, 1059.3819301892],
    [0.00000033296, 0.59310278598, 17789.845619785],
    [0.00000035954, 1.70875808777, 2352.8661537718],
    [0.00000040938, 2.39850938714, 19651.048481098],
    [0.00000030047, 2.73975124088, 1349.8674096588],
    [0.00000030412, 0.44294464169, 83996.84731811189],
    [0.00000023663, 0.48473622521, 8031.0922630584],
    [0.00000023574, 2.06528133162, 3340.6124266998],
    [0.00000021089, 4.14825468851, 951.7184062506],
    [0.00000024738, 0.21484762138, 3.5904286518],
    [0.00000025352, 3.16470891653, 4690.4798363586],
    [0.00000022823, 5.22195230819, 4705.7323075436],
    [0.00000021419, 1.42563910473, 16730.4636895958],
    [0.00000021891, 5.55594302779, 553.5694028424],
    [0.00000017481, 4.56052900312, 135.0650800354],
    [0.00000019927, 5.22209149316, 12168.0026965746],
    [0.0000001986, 5.77470242235, 6309.3741697912],
    [0.000000203, 0.37133792946, 283.8593188652],
    [0.00000014421, 4.19315052005, 242.728603974],
    [0.00000016225, 5.98837767951, 11769.8536931664],
    [0.00000015077, 4.1956716337, 6256.7775301916],
    [0.00000019124, 3.82219958698, 23581.2581773176],
    [0.00000018888, 5.38626892076, 149854.40013480789],
    [0.00000014346, 3.72355084422, 38.0276726358],
    [0.00000017898, 2.21490566029, 13367.9726311066],
    [0.00000012054, 2.62229602614, 955.5997416086],
    [0.00000011287, 0.17739329984, 4164.311989613],
    [0.00000013973, 4.40134615007, 6681.2248533996],
    [0.00000013621, 1.88934516495, 7632.9432596502],
    [0.00000012503, 1.13052412208, 5.5229243074],
    [0.00000010498, 5.35909979317, 1592.5960136328],
    [0.00000009803, 0.99948172646, 11371.7046897582],
    [0.0000000922, 4.57138585348, 4292.3308329504],
    [0.00000010327, 6.19982170609, 6438.4962494256],
    [0.00000012003, 1.00351462266, 632.7837393132],
    [0.00000010827, 0.32734523824, 103.0927742186],
    [0.00000008356, 4.53902748706, 25132.3033999656],
    [0.00000010005, 6.0291496328, 5746.271337896],
    [0.00000008409, 3.29946177848, 7234.794256242],
    [0.00000008006, 5.82145271855, 28.4491874678],
    [0.00000010523, 0.93870455544, 11926.2544136688],
    [0.00000007686, 3.1214364064, 7238.6755916],
    [0.00000009378, 2.62413793196, 5760.4984318976],
    [0.00000008127, 6.11227839253, 4732.0306273434],
    [0.00000009232, 0.48344234496, 522.5774180938],
    [0.00000009802, 5.24413877132, 27511.4678735372],
    [0.00000007871, 0.99590133077, 5643.1785636774],
    [0.00000008123, 6.27053020099, 426.598190876],
    [0.00000009048, 5.33686323585, 6386.16862421],
    [0.00000008621, 4.16537179089, 7058.5984613154],
    [0.00000006297, 4.71723143652, 6836.6452528338],
    [0.00000007575, 3.97381357237, 11499.6562227928],
    [0.00000007756, 2.95728422442, 23013.5395395872],
    [0.00000007314, 0.60652522715, 11513.8833167944],
    [0.00000005955, 2.87641047954, 6283.14316029419],
    [0.00000006534, 5.79046406784, 18073.7049386502],
    [0.00000007188, 3.99831461988, 74.7815985673],
    [0.00000007346, 4.38582423903, 316.3918696566],
    [0.00000005413, 5.39199023275, 419.4846438752],
    [0.00000005127, 2.36059551778, 10973.55568635],
    [0.00000007056, 0.32258442532, 263.0839233728],
    [0.00000006624, 3.6647416584, 17298.1823273262],
    [0.00000006762, 5.91131766896, 90955.5516944961],
    [0.00000004938, 5.73672172371, 9917.6968745098],
    [0.00000005547, 2.45152589382, 12352.8526045448],
    [0.00000005958, 3.3205134466, 6283.0085396886],
    [0.00000004471, 2.06386138131, 7079.3738568078],
    [0.00000006153, 1.45823347458, 233141.31440436149],
    [0.00000004348, 4.42338625285, 5216.5803728014],
    [0.00000006124, 1.07494838623, 19804.8272915828],
    [0.00000004488, 3.65285033073, 206.1855484372],
    [0.0000000402, 0.83995823171, 20.3553193988],
    [0.00000005188, 4.06503864016, 6208.2942514241],
    [0.00000005307, 0.38216728132, 31441.6775697568],
    [0.00000003785, 2.34369213733, 3.881335358],
    [0.00000004497, 3.27230792447, 11015.1064773348],
    [0.00000004132, 0.92129851256, 3738.761430108],
    [0.00000003521, 5.9784480361, 3894.1818295422],
    [0.00000004215, 1.90601721876, 245.8316462294],
    [0.00000003701, 5.03067498875, 536.8045120954],
    [0.00000003866, 1.82632980909, 11856.2186514245],
    [0.00000003652, 1.01840564429, 16200.7727245012],
    [0.0000000339, 0.97784870142, 8635.9420037632],
    [0.00000003737, 2.9537891957, 3128.3887650958],
    [0.00000003507, 3.71291946317, 6290.1893969922],
    [0.00000003086, 3.64646921512, 10.6366653498],
    [0.00000003397, 1.10589356888, 14712.317116458],
    [0.00000003334, 0.83684903082, 6496.3749454294],
    [0.00000002805, 2.58503711584, 14314.1681130498],
    [0.0000000365, 1.08344142571, 88860.05707098669],
    [0.00000003388, 3.20182380957, 5120.6011455836],
    [0.00000003252, 3.47857474229, 6133.5126528568],
    [0.00000002553, 3.9486902726, 1990.745017041],
    [0.0000000352, 2.05559692878, 244287.60000722769],
    [0.00000002565, 1.56072409371, 23543.23050468179],
    [0.00000002621, 3.85639359951, 266.6070417218],
    [0.00000002954, 3.39692614359, 9225.539273283],
    [0.00000002876, 6.02633318445, 154717.60988768269],
    [0.00000002395, 1.16130078696, 10984.1923516998],
    [0.00000003161, 1.32798862116, 10873.9860304804],
    [0.00000003163, 5.08946546862, 21228.3920235458],
    [0.00000002361, 4.27212461943, 6040.3472460174],
    [0.0000000303, 1.80210001168, 35371.8872659764],
    [0.00000002343, 3.57688971514, 10969.9652576982],
    [0.00000002618, 2.57870151918, 22483.84857449259],
    [0.00000002113, 3.71711179417, 65147.6197681377],
    [0.00000002019, 0.81393923319, 170.6728706192],
    [0.00000002003, 0.38091017375, 6172.869528772],
    [0.00000002506, 3.74378169126, 10575.4066829418],
    [0.00000002381, 0.10581361289, 7.046236698],
    [0.00000001949, 4.86892513469, 36.0278666774],
    [0.00000002074, 4.22802468213, 5650.2921106782],
    [0.00000001924, 5.59460549844, 6282.0955289232],
    [0.00000001949, 1.06999605576, 5230.807466803],
    [0.00000001988, 5.19734705445, 6262.300454499],
    [0.00000001887, 3.74365662683, 23.8784377478],
    [0.00000001787, 1.25929659066, 12559.038152982],
    [0.00000001883, 1.90364058477, 15.252471185],
    [0.00000001816, 3.68083794819, 15110.4661198662],
    [0.00000001701, 4.41109562589, 110.2063212194],
    [0.0000000199, 3.93295788548, 6206.8097787158],
    [0.00000002103, 0.75354936681, 13521.7514415914],
    [0.00000001774, 0.48750515837, 1551.045222648],
    [0.00000001882, 0.86685462305, 22003.9146348698],
    [0.00000001924, 1.22901099088, 709.9330485583],
    [0.00000002073, 4.62531597856, 6037.244203762],
    [0.00000001924, 0.60231842492, 6284.0561710596],
    [0.00000001596, 3.98332879712, 13916.0191096416],
    [0.00000001664, 4.41947015623, 8662.240323563],
    [0.00000001971, 1.04560686192, 18209.33026366019],
    [0.00000001942, 4.31335979989, 6244.9428143536],
    [0.00000001476, 0.93274523818, 2379.1644735716],
    [0.0000000181, 0.49112137707, 1.4844727083],
    [0.00000001346, 1.51574753411, 4136.9104335162],
    [0.00000001528, 5.61833568587, 6127.6554505572],
    [0.00000001791, 3.22191142746, 39302.096962196],
    [0.00000001747, 3.05595292589, 18319.5365848796],
    [0.00000001432, 4.51123984264, 20426.571092422],
    [0.00000001695, 0.22049418623, 25158.6017197654],
    [0.00000001242, 4.46665354536, 17256.6315363414],
    [0.00000001463, 4.69248613506, 14945.3161735544],
    [0.00000001205, 1.86911906771, 4590.910180489],
    [0.0000000119, 2.74169967367, 12569.6748183318],
    [0.00000001222, 5.18120087481, 5333.9002410216],
    [0.0000000139, 5.42888623322, 143571.32428481648],
    [0.00000001473, 1.70487100866, 11712.9553182308],
    [0.00000001362, 2.61069503292, 6062.6632075526],
    [0.00000001148, 6.0300843061, 3634.6210245184],
    [0.00000001198, 5.15296117339, 10177.2576795336],
    [0.00000001266, 0.11422490557, 18422.62935909819],
    [0.00000001411, 1.09910890045, 3496.032826134],
    [0.00000001349, 2.99804623019, 17654.7805397496],
    [0.00000001253, 2.79844902576, 167283.76158766549],
    [0.00000001311, 1.609410743, 5481.2549188676],
    [0.00000001079, 6.20304501787, 3.2863574178],
    [0.00000001181, 1.20653777627, 131.5419616864],
    [0.00000001254, 5.45103277799, 6076.8903015542],
    [0.00000001036, 2.32136959491, 7342.4577801806],
    [0.00000001117, 0.38842340979, 949.1756089698],
    [0.00000000966, 3.18352079941, 11087.2851259184],
    [0.00000001171, 3.39635167732, 12562.6285816338],
    [0.00000001121, 0.72631814699, 220.4126424388],
    [0.00000001024, 2.19381113265, 11403.676995575],
    [0.00000000888, 3.91167196431, 4686.8894077068],
    [0.0000000091, 1.98802695087, 735.8765135318],
    [0.00000000823, 0.48822202854, 24072.9214697764],
    [0.00000001096, 6.17377835617, 5436.9930152402],
    [0.00000000908, 0.44959148878, 7477.522860216],
    [0.00000000974, 1.52996313552, 9623.6882766912],
    [0.0000000084, 1.79540573407, 5429.8794682394],
    [0.00000000778, 6.17703744517, 38.1330356378],
    [0.00000000776, 4.09859968447, 14.2270940016],
    [0.00000001068, 4.64209577648, 43232.3066584156],
    [0.00000000954, 1.49985885818, 1162.4747044078],
    [0.00000000907, 0.86986870809, 10344.2950653858],
    [0.00000000931, 4.06049877517, 28766.924424484],
    [0.00000000739, 5.04368192034, 639.897286314],
    [0.00000000965, 3.44286716197, 1589.0728952838],
    [0.00000000763, 5.86304776787, 16858.4825329332],
    [0.00000000953, 4.20801492835, 11190.377900137],
    [0.00000000708, 1.72432323967, 13095.8426650774],
    [0.00000000969, 1.64437243011, 29088.811415985],
    [0.00000000717, 0.16688678895, 11.729352836],
    [0.00000000962, 3.53101876172, 12416.5885028482],
    [0.00000000745, 5.77741082302, 12592.4500197826],
    [0.00000000672, 1.91091228744, 3.9321532631],
    [0.00000000671, 5.46240758839, 18052.9295431578],
    [0.00000000675, 6.28311649798, 4535.0594369244],
    [0.00000000684, 0.39975011401, 5849.3641121146],
    [0.00000000799, 0.29859056777, 12132.439962106],
    [0.00000000758, 0.96370719224, 1052.2683831884],
    [0.00000000782, 5.33875702541, 13517.8701062334],
    [0.0000000073, 1.70114998543, 17267.26820169119],
    [0.00000000749, 2.59607005624, 11609.8625440122],
    [0.00000000734, 2.7842049778, 640.8776073822],
    [0.00000000688, 5.15097673557, 16496.3613962024],
    [0.0000000077, 1.62459252416, 4701.1165017084],
    [0.00000000633, 2.20588443066, 25934.1243310894],
    [0.0000000076, 4.21317219403, 377.3736079158],
    [0.00000000584, 2.13420121623, 10557.5941608238],
    [0.00000000572, 0.24649745829, 9779.1086761254],
    [0.00000000573, 3.16435264609, 533.2140834436],
    [0.00000000685, 3.19344289472, 12146.6670561076],
    [0.00000000675, 0.96179234176, 10454.5013866052],
    [0.00000000648, 1.46327342554, 6268.8487559898],
    [0.00000000589, 2.50543543638, 3097.88382272579],
    [0.00000000551, 5.28106257475, 9388.0059094152],
    [0.00000000696, 3.6534215555, 4804.209275927],
    [0.00000000669, 2.5103005926, 2388.8940204492],
    [0.0000000055, 0.06883090057, 20199.094959633],
    [0.00000000629, 4.13350997495, 45892.73043315699],
    [0.00000000678, 6.09190163533, 135.62532501],
    [0.00000000593, 1.50129499103, 226858.23855437008],
    [0.00000000542, 3.58582033525, 6148.010769956],
    [0.00000000599, 6.12058050643, 18875.525869774],
    [0.00000000682, 5.0221361683, 17253.04110768959],
    [0.00000000565, 4.29309214275, 11933.3679606696],
    [0.00000000486, 0.77746204893, 27.4015560968],
    [0.00000000503, 0.58974557727, 15671.0817594066],
    [0.00000000616, 4.06539884128, 227.476132789],
    [0.00000000537, 2.15064382406, 21954.15760939799],
    [0.00000000669, 6.06995500278, 47162.5163546352],
    [0.0000000054, 2.83444221432, 5326.7866940208],
    [0.00000000474, 0.40346826846, 6915.8595893046],
    [0.00000000532, 5.26131065063, 10988.808157535],
    [0.00000000582, 3.24533095664, 153.7788104848],
    [0.00000000641, 3.24711790399, 2107.0345075424],
    [0.00000000619, 3.08302108547, 33019.0211122046],
    [0.00000000466, 3.14982369789, 10440.2742926036],
    [0.00000000466, 0.90708835651, 5966.6839803348],
    [0.00000000528, 0.8192645447, 813.5502839598],
    [0.00000000603, 3.81378921927, 316428.22867391503],
    [0.00000000559, 1.8189498573, 17996.0311682222],
    [0.00000000437, 2.28631745987, 6303.8512454838],
    [0.00000000518, 4.86068318058, 20597.2439630412],
    [0.00000000424, 6.23520018697, 6489.2613984286],
    [0.00000000518, 6.17617826756, 0.2438174835],
    [0.00000000404, 5.72804304258, 5642.1982426092],
    [0.00000000458, 1.34117773914, 6287.0080032545],
    [0.00000000548, 5.6845445832, 155427.54293624099],
    [0.00000000547, 1.03391472434, 3646.3503773544],
    [0.00000000428, 4.6980968782, 846.0828347512],
    [0.00000000413, 6.0252069939, 6279.4854213396],
    [0.00000000534, 3.03030638223, 66567.48586525429],
    [0.00000000383, 1.4905558804, 19800.9459562248],
    [0.00000000411, 5.28384176408, 18451.07854656599],
    [0.00000000352, 4.68891600525, 4907.3020501456],
    [0.0000000048, 5.36572651091, 348.924420448],
    [0.00000000344, 5.89157452889, 6546.1597733642],
    [0.0000000034, 0.37557440365, 13119.72110282519],
    [0.00000000434, 4.98417856239, 6702.5604938666],
    [0.00000000332, 2.6890934443, 29296.6153895786],
    [0.00000000448, 2.16478480251, 5905.7022420756],
    [0.00000000344, 2.06546633735, 49.7570254718],
    [0.00000000315, 1.24023810969, 4061.2192153944],
    [0.00000000324, 2.30897526929, 5017.508371365],
    [0.00000000413, 0.17171692945, 6286.6662786432],
    [0.00000000431, 3.8660110138, 12489.8856287072],
    [0.00000000349, 4.55372493131, 4933.2084403326],
    [0.00000000323, 0.41971136084, 10770.8932562618],
    [0.00000000341, 2.68612860807, 11.0457002639],
    [0.00000000316, 3.52966641606, 17782.7320727842],
    [0.00000000315, 5.63357264999, 568.8218740274],
    [0.0000000034, 3.83571212349, 10660.6869350424],
    [0.00000000296, 0.62703270489, 20995.3929664494],
    [0.00000000405, 1.00084965393, 16460.33352952499],
    [0.00000000414, 1.21998752076, 51092.7260508548],
    [0.00000000336, 4.71465945215, 6179.9830757728],
    [0.00000000361, 3.71235613733, 28237.2334593894],
    [0.00000000327, 1.05606504715, 11919.140866668],
    [0.00000000327, 6.1422242098, 6254.6266625236],
    [0.00000000268, 2.47224339737, 664.75604513],
    [0.00000000269, 1.86210872453, 23141.5583829246],
    [0.00000000345, 0.93461290184, 6058.7310542895],
    [0.00000000353, 4.50033650657, 36949.2308084242],
    [0.00000000344, 6.26166140367, 24356.7807886416],
    [0.000000003, 4.46964001975, 6418.1409300268],
    [0.0000000026, 4.04967464725, 6525.8044539654],
    [0.00000000298, 2.20018811054, 156137.47598479928],
    [0.00000000253, 3.49930797865, 29864.334027309],
    [0.00000000254, 2.44883530154, 5331.3574437408],
    [0.00000000296, 0.84341183907, 5729.506447149],
    [0.00000000241, 2.00721298729, 16737.5772365966],
    [0.00000000311, 1.23668016336, 6281.5913772831],
    [0.00000000332, 3.55576945724, 7668.6374249425],
    [0.00000000236, 2.47437156031, 6245.0481773556],
    [0.00000000264, 4.43924412283, 12964.300703391],
    [0.00000000257, 1.79654471948, 11080.1715789176],
    [0.0000000026, 3.3307759606, 5888.4499649322],
    [0.00000000285, 0.3088636143, 11823.1616394502],
    [0.0000000029, 5.70141882483, 77.673770428],
    [0.00000000255, 4.00939662024, 5881.4037282342],
    [0.00000000253, 4.73318512715, 16723.350142595],
    [0.00000000228, 0.95333661324, 5540.0857894588],
    [0.00000000281, 1.29199646396, 22805.7355659936],
    [0.00000000319, 1.38633229189, 163096.18036118349],
    [0.00000000224, 1.65156322696, 10027.9031957292],
    [0.00000000226, 0.34125379653, 17796.9591667858],
    [0.00000000236, 4.19817431922, 19.66976089979],
    [0.00000000281, 4.14114899916, 12539.853380183],
    [0.00000000275, 5.50306930248, 32.5325507914],
    [0.00000000223, 5.23334210294, 56.8983749356],
    [0.00000000217, 6.08598789777, 6805.6532680852],
    [0.00000000228, 5.17114391778, 11720.0688652316],
    [0.00000000274, 4.50716805713, 6016.4688082696],
    [0.00000000245, 3.96486270306, 22.7752014508],
    [0.0000000022, 4.7207808197, 6.62855890001],
    [0.00000000207, 5.71701403951, 41.5507909848],
    [0.00000000204, 3.9122741125, 2699.7348193176],
    [0.00000000209, 0.86881969024, 6321.1035226272],
    [0.000000002, 2.11984442601, 4274.5183108324],
    [0.000000002, 5.39839888151, 6019.9919266186],
    [0.00000000209, 5.67606291663, 11293.4706743556],
    [0.00000000252, 1.6496572935, 9380.9596727172],
    [0.00000000275, 5.04826903506, 73.297125859],
    [0.00000000208, 1.88207277133, 11300.5842213564],
    [0.00000000206, 5.0728488933, 6277.552925684],
    [0.00000000272, 0.74640924904, 1975.492545856],
    [0.00000000199, 3.30813142103, 22743.4093795164],
    [0.00000000269, 4.48560812155, 64471.99124174489],
    [0.00000000192, 2.17463565107, 5863.5912061162],
    [0.00000000228, 5.85373115869, 128.0188433374],
    [0.00000000261, 2.64321183295, 55022.9357470744],
    [0.00000000196, 2.4853762232, 16062.1845261168],
    [0.00000000187, 1.3189176028, 29826.3063546732],
    [0.0000000022, 5.75012110079, 29.429508536],
    [0.00000000187, 4.03230554718, 467.9649903544],
    [0.000000002, 5.60555262896, 1066.49547719],
    [0.00000000231, 1.09802712785, 12341.8069042809],
    [0.00000000198, 0.29474229005, 149.5631971346],
    [0.00000000249, 5.1047702317, 7875.6718636242],
    [0.00000000179, 0.87066197995, 12721.572099417],
    [0.00000000203, 1.56914310573, 28286.9904848612],
    [0.00000000198, 3.54061588502, 30.914125635],
    [0.00000000171, 3.45366018621, 5327.4761083828],
    [0.00000000183, 0.72325421604, 6272.0301497275],
    [0.00000000216, 2.97175184412, 19402.7969528166],
    [0.00000000168, 2.51559879907, 23937.856389741],
    [0.00000000195, 0.09045393425, 156.4007205024],
    [0.00000000216, 0.42162375972, 23539.7073863328],
    [0.00000000189, 0.37542530191, 9814.6041002912],
    [0.00000000207, 2.01752547259, 238004.52415723629],
    [0.00000000218, 2.36835893645, 16627.3709153772],
    [0.00000000166, 4.23182960518, 16840.67001081519],
    [0.000000002, 2.02153258098, 16097.6799502826],
    [0.00000000169, 0.91318727, 95.9792272178],
    [0.00000000211, 5.73370637657, 151.8972810852],
    [0.00000000204, 0.42643085174, 515.463871093],
    [0.00000000212, 3.00223140894, 12043.574281889],
    [0.00000000192, 5.46153589821, 6379.0550772092],
    [0.0000000016, 6.23798383332, 202.2533951741],
    [0.00000000215, 0.20889073407, 5621.8429232104],
    [0.0000000015, 3.12999753018, 799.8211251654],
    [0.00000000187, 2.12345787867, 491.6632924588],
    [0.00000000192, 1.33928820063, 394.6258850592],
    [0.00000000149, 2.65697593276, 21.335640467],
    [0.00000000146, 5.58021191726, 412.3710968744],
    [0.00000000156, 3.7565767638, 12323.4230960088],
    [0.00000000143, 3.28248547724, 29.8214381488],
    [0.00000000144, 1.07862546598, 1265.5674786264],
    [0.00000000148, 0.2338663109, 10021.8372800994],
    [0.00000000164, 0.94288727597, 14919.0178537546],
    [0.00000000193, 5.92751083827, 40879.4405046438],
    [0.0000000014, 4.97612440269, 158.9435177832],
    [0.00000000148, 2.61651818006, 17157.0618804718],
    [0.0000000014, 3.66947933935, 26084.0218062162],
    [0.00000000147, 5.09968173403, 661.232926781],
    [0.00000000147, 1.36976712162, 4171.4255366138],
    [0.00000000134, 4.79432636012, 111.1866422876],
    [0.0000000014, 1.27748013377, 107.6635239386],
    [0.00000000171, 2.77586207403, 26735.9452622132],
    [0.00000000183, 5.43418358741, 369.6998159404],
    [0.00000000134, 3.09132862833, 17.812522118],
    [0.00000000132, 3.05633896779, 22490.9621214934],
    [0.00000000181, 4.22950689891, 966.9708774356],
    [0.00000000166, 3.67660435776, 15508.6151232744],
    [0.00000000152, 5.28885813387, 12669.2444742014],
    [0.0000000015, 5.86819430895, 97238.62754448749],
    [0.00000000145, 5.07330784304, 87.30820453981],
    [0.00000000133, 5.65471067133, 31.9723058168],
    [0.00000000124, 2.83326216907, 12566.2190102856],
    [0.0000000014, 5.84212721453, 22476.73502749179],
    [0.00000000134, 3.12858101887, 32217.2001810808],
    [0.00000000137, 0.86487461904, 9924.8104215106],
    [0.00000000172, 1.98369595114, 174242.4659640497],
    [0.0000000017, 4.41115280254, 327574.51427678125],
    [0.00000000128, 4.49087631612, 31415.379249957],
    [0.00000000151, 0.46542092001, 39609.6545831656],
    [0.00000000153, 3.78801830344, 17363.24742890899],
    [0.00000000165, 5.31654110459, 16943.7627850338],
    [0.00000000165, 4.06747587817, 58953.145443294],
    [0.00000000118, 0.63846333239, 6.0659156298],
    [0.00000000159, 0.86086959274, 221995.02880149524],
    [0.00000000119, 5.96432932413, 1385.8952763362],
    [0.00000000114, 5.16516114595, 25685.872802808],
    [0.00000000112, 4.92889233335, 56.8032621698],
    [0.00000000119, 2.40626699328, 18635.9284545362],
    [0.00000000115, 0.23374479051, 418.9243989006],
    [0.00000000113, 2.7938757674, 6272.4391846416],
    [0.00000000122, 0.936940724, 24492.40611365159],
    [0.00000000133, 4.87155573413, 22345.2603761082],
    [0.00000000113, 3.80362889046, 6293.7125153412],
    [0.0000000013, 3.72996018683, 12573.2652469836],
    [0.00000000107, 3.40227152756, 21393.5419698576],
    [0.00000000122, 1.00385670948, 95143.1329209781],
    [0.0000000014, 1.094130757, 44809.6502008634],
    [0.00000000112, 6.05462382871, 433.7117378768],
    [0.00000000123, 4.55640196386, 239424.39025435288],
    [0.00000000104, 1.54931540602, 127.9515330346],
    [0.00000000111, 3.04186517428, 8982.810669309],
    [0.00000000102, 4.12448497391, 15664.03552270859],
    [0.00000000107, 4.67919356465, 77690.75950573849],
    [0.00000000118, 4.5232017012, 19004.6479494084],
    [0.00000000107, 5.71774478555, 77736.78343050249],
    [0.00000000103, 4.79332126649, 33794.5437235286],
    [0.00000000143, 1.81201813018, 4214.0690150848],
    [0.00000000102, 3.7581778657, 58864.5439181463],
    [0.00000000125, 1.14419195615, 625.6701923124],
    [0.00000000124, 3.27736513892, 12566.08438968],
    [0.0000000011, 1.08705709966, 2787.0430238574],
    [0.00000000102, 4.75119578149, 12242.6462833254],
    [0.00000000101, 4.91289409429, 401.6721217572],
    [0.00000000138, 2.89578979744, 9411.4646150872],
    [0.00000000129, 1.23516042371, 12029.3471878874],
    [0.00000000138, 2.45654707076, 7576.560073574],
    [0.00000000098, 5.4477176502, 29026.48522950779],
    [0.00000000134, 1.43105174912, 86464.61331683119],
    [0.00000000108, 0.9898977494, 5636.0650166766],
    [0.00000000117, 5.17362847134, 34520.3093093808],
    [0.00000000097, 3.34717130592, 16310.9790457206],
    [0.00000000107, 2.94547931851, 24602.61243487099],
    [0.00000000098, 4.37041908717, 34513.2630726828],
    [0.00000000125, 2.72182830814, 24065.80792277559],
    [0.00000000111, 0.58899131543, 6303.4311693902],
    [0.00000000102, 0.66938025772, 10239.5838660108],
    [0.00000000119, 1.21666517886, 1478.8665740644],
    [0.00000000111, 1.04321934681, 16522.6597160022],
    [0.00000000094, 4.31076339857, 26880.3198130326],
    [0.00000000098, 4.14248433763, 6599.467719648],
    [0.00000000095, 2.89807657534, 34911.412076091],
    [0.00000000097, 0.89642320201, 71980.63357473118],
    [0.00000000095, 0.65717727948, 6288.5987742988],
    [0.00000000116, 4.19967201116, 206.7007372966],
    [0.00000000095, 1.78315464297, 18139.2945014159],
    [0.00000000099, 1.37437847718, 1039.0266107904],
    [0.00000000126, 3.21642544972, 305281.94307104882],
    [0.00000000094, 0.6899503186, 7834.1210726394],
    [0.00000000095, 5.58111421744, 3104.9300594238],
    [0.00000000108, 0.52696637156, 276.7457718644],
    [0.00000000124, 3.43899862683, 172146.97134054029],
    [0.00000000087, 1.18764938806, 18842.11400297339],
    [0.00000000087, 0.09094166389, 15141.390794312],
    [0.00000000108, 1.03363414379, 82576.98122099529],
    [0.00000000119, 2.86729109648, 90394.82301305079],
    [0.00000000104, 3.39218586218, 290.972865866],
    [0.00000000094, 5.68284937444, 32367.0976562076],
    [0.00000000117, 0.78475956902, 83286.91426955358],
    [0.00000000105, 3.96551057233, 6357.8574485587],
    [0.00000000094, 4.03443174853, 13341.6743113068],
    [0.00000000096, 0.92742567538, 1062.9050485382],
    [0.00000000089, 4.45371820659, 792.7748884674],
    [0.00000000087, 0.40013481685, 90279.92316810328],
    [0.00000000113, 2.48165313368, 48739.859897083],
    [0.00000000087, 3.43122851097, 27707.5424942948],
    [0.00000000101, 5.32081603011, 2301.58581590939],
    [0.00000000084, 0.67020912458, 28628.3362260996],
    [0.00000000082, 0.87060089842, 10241.2022911672],
    [0.00000000086, 4.6206479229, 36147.4098773004],
    [0.0000000008, 4.77649625396, 6819.8803620868],
    [0.00000000095, 2.87032913492, 23020.65308658799],
    [0.00000000107, 5.77864921649, 34115.1140692746],
    [0.0000000011, 3.32898859416, 72140.62866668739],
    [0.00000000087, 4.40657711727, 142.1786270362],
    [0.00000000103, 4.2250672681, 30666.1549584328],
    [0.00000000082, 3.89404392552, 5547.1993364596],
    [0.00000000109, 1.94546065204, 24279.10701821359],
    [0.00000000087, 4.32472045435, 742.9900605326],
    [0.00000000107, 4.91580912547, 277.0349937414],
    [0.00000000088, 2.10180817713, 26482.1708096244],
    [0.00000000086, 4.01895021483, 12491.3701014155],
    [0.00000000106, 5.49092372854, 62883.3551395136],
    [0.0000000008, 6.1978570495, 6709.6740408674],
    [0.00000000105, 2.44166529175, 6298.3283211764],
    [0.00000000083, 4.90662164029, 51.28033786241],
    [0.00000000074, 2.34622575625, 7018.9523635232],
    [0.00000000078, 6.06947270265, 148434.53403769129],
    [0.00000000079, 3.03048221644, 838.9692877504],
    [0.00000000073, 3.05008665738, 567.7186377304],
    [0.00000000102, 3.59223815483, 22380.755800274],
    [0.00000000084, 0.46604373274, 45.1412196366],
    [0.00000000092, 4.12917744733, 18216.443810661],
    [0.00000000091, 0.49382398887, 6453.7487206106],
    [0.00000000073, 1.72446569088, 21424.4666443034],
    [0.00000000069, 1.4937267773, 21548.9623692918],
    [0.00000000069, 4.73181018058, 8858.3149443206],
    [0.00000000077, 0.47683782532, 11520.9968637952],
    [0.00000000078, 5.4394263099, 15265.8865193004],
    [0.00000000077, 2.53773750372, 76.2660712756],
    [0.00000000069, 2.53932635192, 9910.583327509],
    [0.00000000075, 0.1559472921, 23006.42599258639],
    [0.00000000078, 2.41004950269, 6393.2821712108],
    [0.00000000067, 5.05152846816, 57375.8019008462],
    [0.00000000077, 3.9107560486, 24383.0791084414],
    [0.00000000067, 0.78239147387, 12779.4507954208],
    [0.00000000071, 1.24817900687, 10419.9862835076],
    [0.00000000067, 5.7785122776, 6311.5250374592],
    [0.00000000061, 2.66705754411, 18852.7506683232],
    [0.00000000079, 1.89137330427, 6528.9074962208],
    [0.00000000084, 5.11523704221, 50317.2034395308],
    [0.00000000059, 3.38290426621, 35707.7100829074],
    [0.00000000065, 4.66767908854, 26709.6469424134],
    [0.00000000079, 5.59773848156, 71960.38658322369],
    [0.00000000061, 3.30733768968, 18845.7044316252],
    [0.00000000057, 3.90831298022, 5999.2165311262],
    [0.00000000058, 3.92572820333, 30348.883772767],
    [0.00000000061, 0.05695045822, 7856.89627409019],
    [0.00000000061, 5.63297960691, 7863.9425107882],
    [0.00000000068, 2.53986117507, 20452.8694122218],
    [0.00000000053, 5.44021645443, 32370.9789915656],
    [0.00000000059, 4.95695131145, 11925.2740926006],
    [0.00000000059, 5.34668243273, 137288.24843482509],
    [0.00000000056, 4.05779957425, 17892.93839400359],
    [0.00000000053, 3.94182462468, 18624.8827542723],
    [0.00000000049, 2.11782803206, 22594.05489571199],
    [0.00000000062, 2.47154086715, 12345.739057544],
    [0.00000000049, 5.7659693738, 18606.4989460002],
    [0.00000000052, 6.20902099741, 21947.1113727],
    [0.00000000051, 3.13287981215, 33326.5787331742],
    [0.00000000057, 6.17003357597, 61306.0115970658],
    [0.00000000064, 5.66596451842, 34596.3646546524],
    [0.00000000066, 3.922623355, 69853.35207568129],
    [0.00000000053, 5.51119362049, 77710.24834977149],
    [0.00000000053, 4.88573986965, 77717.29458646949],
    [0.00000000048, 2.71399112516, 20760.4270331914],
    [0.00000000046, 6.08376164442, 29822.7832363242],
    [0.00000000052, 0.3139748138, 37724.7534197482],
    [0.00000000045, 5.53587248663, 6262.7205305926],
    [0.00000000059, 2.45437896854, 69166.430989505],
    [0.0000000006, 5.24261569842, 56600.2792895222],
    [0.00000000051, 6.15794342172, 11616.976091013],
    [0.0000000006, 1.74758109828, 44034.1275895394],
    [0.00000000049, 5.08973141046, 33990.6183442862],
    [0.00000000044, 3.28270864884, 29424.634232916],
    [0.00000000052, 5.34866947943, 28313.288804661],
    [0.00000000059, 2.12384971916, 36173.7081971002],
    [0.0000000005, 0.46480931695, 25287.7237993998],
    [0.00000000044, 2.0550351721, 63658.8777508376],
    [0.00000000044, 1.71009200258, 13362.4497067992],
    [0.00000000041, 3.91721318316, 6279.1945146334],
    [0.00000000042, 1.52106001448, 23550.34405168259],
    [0.00000000042, 3.10938258068, 84672.47584450469],
    [0.00000000041, 3.78863023321, 35050.00027447539],
    [0.00000000042, 5.57543459263, 38500.2760310722],
    [0.0000000004, 5.55145719363, 12565.1713789146],
    [0.00000000054, 0.889354921, 50290.905119731],
    [0.00000000055, 2.50268487636, 77828.671313068],
    [0.00000000054, 4.16257918787, 22910.44676536859],
    [0.00000000041, 2.32141215064, 6286.9571853494],
    [0.00000000045, 3.18590576311, 45585.1728121874],
    [0.00000000045, 2.24348941683, 23646.32327890039],
    [0.00000000043, 3.8789211095, 6549.6828917132],
    [0.00000000048, 2.11364139445, 31570.7996493912],
    [0.00000000043, 5.55099558987, 12359.9661515456],
    [0.00000000041, 4.88191569433, 23536.11695768099],
    [0.00000000049, 2.44790922235, 13613.804277336],
    [0.00000000047, 3.5818169391, 4797.0957289262],
];

const VSOP87_L1: Vsop87Element = [
    [6283.0758499914],
    [0.00206058863, 2.67823455808, 6283.0758499914],
    [0.00004303419, 2.63512233481, 12566.1516999828],
    [0.00000425264, 1.59046982018, 3.523118349],
    [0.00000109017, 2.96631010675, 1577.3435424478],
    [0.00000093479, 2.59211109542, 18849.2275499742],
    [0.00000119305, 5.79555765566, 26.2983197998],
    [0.00000072121, 1.13840581212, 529.6909650946],
    [0.00000067784, 1.87453300345, 398.1490034082],
    [0.0000006735, 4.40932832004, 5507.5532386674],
    [0.00000059045, 2.88815790631, 5223.6939198022],
    [0.00000055976, 2.17471740035, 155.4203994342],
    [0.00000045411, 0.39799502896, 796.2980068164],
    [0.00000036298, 0.46875437227, 775.522611324],
    [0.00000028962, 2.64732254645, 7.1135470008],
    [0.00000019097, 1.84628376049, 5486.777843175],
    [0.00000020844, 5.34138275149, 0.9803210682],
    [0.00000018508, 4.96855179468, 213.299095438],
    [0.00000016233, 0.03216587315, 2544.3144198834],
    [0.00000017293, 2.9911676063, 6275.9623029906],
    [0.00000015832, 1.43049301283, 2146.1654164752],
    [0.00000014608, 1.2046979369, 10977.078804699],
    [0.00000011877, 3.25805082007, 5088.6288397668],
    [0.00000011514, 2.07502080082, 4694.0029547076],
    [0.00000009721, 4.2392586526, 1349.8674096588],
    [0.00000009969, 1.30263423409, 6286.5989683404],
    [0.00000009452, 2.69956827011, 242.728603974],
    [0.00000012461, 2.83432282119, 1748.016413067],
    [0.00000011808, 5.27379760438, 1194.4470102246],
    [0.00000008577, 5.6447608598, 951.7184062506],
    [0.00000010641, 0.76614722966, 553.5694028424],
    [0.00000007576, 5.30056172859, 2352.8661537718],
    [0.00000005764, 1.77228445837, 1059.3819301892],
    [0.00000006385, 2.65034514038, 9437.762934887],
    [0.00000005223, 5.66135782131, 71430.69561812909],
    [0.00000005315, 0.91110018969, 3154.6870848956],
    [0.00000006101, 4.66633726278, 4690.4798363586],
    [0.00000004335, 0.23934560382, 6812.766815086],
    [0.00000005041, 1.42489704722, 6438.4962494256],
    [0.00000004259, 0.77355543889, 10447.3878396044],
    [0.000000052, 1.85528830215, 801.8209311238],
    [0.00000003744, 2.00119905572, 8031.0922630584],
    [0.00000003553, 2.42789590229, 14143.4952424306],
    [0.00000003372, 3.86210786421, 1592.5960136328],
    [0.0000000338, 0.88545388924, 12036.4607348882],
    [0.00000003196, 3.19713328141, 4705.7323075436],
    [0.00000003221, 0.6160104899, 8429.2412664666],
    [0.00000004132, 5.23992584671, 7084.8967811152],
    [0.0000000297, 6.07029819073, 4292.3308329504],
    [0.000000029, 2.32464208411, 20.3553193988],
    [0.00000003504, 4.79976712702, 6279.5527316424],
    [0.0000000295, 1.43108874817, 5746.271337896],
    [0.00000002697, 4.80365209201, 7234.794256242],
    [0.00000002531, 6.22289990904, 6836.6452528338],
    [0.00000002745, 0.93466065396, 5760.4984318976],
    [0.0000000325, 3.39951915286, 7632.9432596502],
    [0.00000002278, 5.00339914806, 17789.845619785],
    [0.00000002076, 3.95551309007, 10213.285546211],
    [0.00000002061, 2.2240771919, 5856.4776591154],
    [0.00000002252, 5.67166717686, 11499.6562227928],
    [0.00000002148, 5.20182663314, 11513.8833167944],
    [0.00000001886, 0.53198539077, 3340.6124266998],
    [0.00000001875, 4.73511969924, 83996.84731811189],
    [0.0000000206, 2.54985307819, 25132.3033999656],
    [0.00000001794, 1.47435300254, 4164.311989613],
    [0.00000001778, 3.02473091781, 5.5229243074],
    [0.00000002036, 0.90908165072, 6256.7775301916],
    [0.00000002064, 2.27051326957, 522.5774180938],
    [0.00000001773, 3.03090500693, 5753.3848848968],
    [0.00000001569, 6.12406216872, 5216.5803728014],
    [0.0000000159, 4.63713748247, 3.2863574178],
    [0.00000001533, 4.20305593883, 13367.9726311066],
    [0.00000001427, 1.19087535126, 3894.1818295422],
    [0.00000001376, 4.24955891338, 426.598190876],
    [0.00000001375, 3.09301252193, 135.0650800354],
    [0.00000001308, 3.0849213889, 5643.1785636774],
    [0.0000000134, 5.76513167968, 6040.3472460174],
    [0.0000000125, 3.07748196332, 11926.2544136688],
    [0.00000001551, 3.07664090662, 6681.2248533996],
    [0.00000001148, 3.24144202282, 12168.0026965746],
    [0.00000001268, 2.09201189992, 6290.1893969922],
    [0.00000001248, 3.44506939791, 536.8045120954],
    [0.00000001118, 2.31830078762, 16730.4636895958],
    [0.00000001105, 5.31966001019, 23.8784377478],
    [0.00000001012, 3.74953487087, 7860.4193924392],
    [0.00000001025, 2.4468377161, 1990.745017041],
    [0.00000000962, 0.81771017882, 3.881335358],
    [0.00000000911, 0.41724352112, 7079.3738568078],
    [0.00000001091, 3.98233608618, 11506.7697697936],
    [0.00000000957, 4.07671436153, 6127.6554505572],
    [0.00000000835, 5.28348689371, 11790.6290886588],
    [0.00000000802, 3.88779080089, 10973.55568635],
    [0.00000000773, 2.41044394817, 1589.0728952838],
    [0.00000000758, 1.30034365873, 103.0927742186],
    [0.00000000749, 4.96281442361, 6496.3749454294],
    [0.00000000765, 3.36312388424, 36.0278666774],
    [0.00000000915, 5.41549763095, 206.1855484372],
    [0.00000000776, 2.57589060224, 11371.7046897582],
    [0.00000000772, 3.98363364977, 955.5997416086],
    [0.00000000749, 5.17900231417, 10969.9652576982],
    [0.00000000806, 0.34226117299, 9917.6968745098],
    [0.00000000728, 5.20962563787, 38.0276726358],
    [0.00000000685, 2.77592961854, 20.7753954924],
    [0.00000000636, 4.28242193632, 28.4491874678],
    [0.00000000608, 5.63278510221, 10984.1923516998],
    [0.00000000704, 5.60739437733, 3738.761430108],
    [0.00000000685, 0.38876148682, 15.252471185],
    [0.00000000601, 0.73489602442, 419.4846438752],
    [0.00000000716, 2.65286869987, 6309.3741697912],
    [0.00000000584, 5.54508741381, 17298.1823273262],
    [0.00000000628, 1.11733054796, 7058.5984613154],
    [0.00000000688, 2.59684132401, 3496.032826134],
    [0.00000000485, 0.44470714066, 12352.8526045448],
    [0.00000000562, 2.82510352358, 3930.2096962196],
    [0.00000000597, 5.27675789973, 10575.4066829418],
    [0.00000000583, 3.1893153986, 4732.0306273434],
    [0.00000000526, 5.01737745304, 5884.9268465832],
    [0.0000000054, 1.29182747488, 640.8776073822],
    [0.00000000481, 5.49721461067, 5230.807466803],
    [0.00000000406, 5.21253018484, 220.4126424388],
    [0.00000000395, 1.87489912123, 16200.7727245012],
    [0.00000000367, 0.88533542945, 6283.14316029419],
    [0.00000000369, 3.84778078192, 18073.7049386502],
    [0.00000000379, 0.37991716505, 10177.2576795336],
    [0.00000000356, 3.84152910109, 11712.9553182308],
    [0.00000000374, 5.01577520608, 7.046236698],
    [0.00000000381, 4.30250406634, 6062.6632075526],
    [0.00000000471, 0.86388942467, 6069.7767545534],
    [0.00000000367, 1.3294383993, 6283.0085396886],
    [0.0000000046, 5.19667219582, 6284.0561710596],
    [0.00000000333, 5.54250425107, 4686.8894077068],
    [0.00000000341, 4.36524495363, 7238.6755916],
    [0.00000000336, 4.00205876835, 3097.88382272579],
    [0.00000000359, 6.22679790284, 245.8316462294],
    [0.00000000307, 2.35299010924, 170.6728706192],
    [0.00000000343, 3.77164927142, 6076.8903015542],
    [0.00000000296, 5.44138799494, 17260.1546546904],
    [0.00000000328, 0.13817705132, 11015.1064773348],
    [0.00000000269, 1.13308244952, 12569.6748183318],
    [0.00000000263, 0.0055073751, 4136.9104335162],
    [0.00000000282, 5.04399588559, 7477.522860216],
    [0.0000000028, 3.13703211405, 12559.038152982],
    [0.00000000259, 0.93882269388, 5642.1982426092],
    [0.00000000292, 1.98426314297, 12132.439962106],
    [0.00000000247, 3.84244798673, 5429.8794682394],
    [0.00000000319, 5.0417014879, 90617.7374312997],
    [0.00000000245, 5.70469737024, 65147.6197681377],
    [0.00000000318, 1.35581968834, 78051.5857313169],
    [0.00000000241, 0.99469787369, 3634.6210245184],
    [0.00000000246, 3.06168069393, 110.2063212194],
    [0.00000000239, 6.11854529589, 11856.2186514245],
    [0.00000000267, 0.65297608414, 21228.3920235458],
    [0.00000000262, 1.51070507866, 12146.6670561076],
    [0.0000000023, 1.75923794017, 9779.1086761254],
    [0.00000000223, 2.00967043606, 6172.869528772],
    [0.00000000246, 1.10411690861, 6282.0955289232],
    [0.00000000214, 4.03840492266, 14314.1681130498],
    [0.00000000212, 2.13695623228, 5849.3641121146],
    [0.00000000207, 3.07724246401, 11.729352836],
    [0.00000000207, 6.10303325026, 23543.23050468179],
    [0.00000000266, 1.00720021877, 2388.8940204492],
    [0.00000000217, 6.27840212312, 17267.26820169119],
    [0.00000000231, 5.37372783468, 13916.0191096416],
    [0.00000000204, 2.34615348695, 266.6070417218],
    [0.00000000195, 5.55015549753, 6133.5126528568],
    [0.00000000203, 4.65616806503, 24072.9214697764],
    [0.00000000188, 2.52682282169, 6525.8044539654],
    [0.00000000177, 1.73426919199, 154717.60988768269],
    [0.00000000187, 4.76501318048, 4535.0594369244],
    [0.00000000186, 4.63080493407, 10440.2742926036],
    [0.00000000183, 3.20060840641, 8635.9420037632],
    [0.00000000172, 1.45551703877, 9225.539273283],
    [0.00000000162, 3.30665137166, 639.897286314],
    [0.00000000168, 2.17671416605, 27.4015560968],
    [0.0000000016, 1.6816871275, 15110.4661198662],
    [0.00000000194, 2.79243768345, 7342.4577801806],
    [0.00000000183, 0.56273524797, 13517.8701062334],
    [0.00000000172, 5.97039514134, 4701.1165017084],
    [0.00000000179, 3.58450811616, 87.30820453981],
    [0.00000000152, 2.84070476839, 5650.2921106782],
    [0.00000000156, 1.07156076421, 18319.5365848796],
    [0.00000000182, 0.44053620124, 17253.04110768959],
    [0.00000000142, 1.4629013752, 11087.2851259184],
    [0.00000000131, 5.40912137746, 2699.7348193176],
    [0.00000000144, 2.07312089638, 25158.6017197654],
    [0.00000000147, 6.15107800602, 9623.6882766912],
    [0.00000000141, 5.55739979498, 10454.5013866052],
    [0.00000000135, 0.0609812943, 16723.350142595],
    [0.00000000123, 5.81194797368, 17256.6315363414],
    [0.00000000124, 2.36269386269, 4933.2084403326],
    [0.00000000126, 3.47483886466, 22483.84857449259],
    [0.00000000159, 5.63944722033, 5729.506447149],
    [0.00000000137, 1.93811728826, 20426.571092422],
    [0.00000000123, 3.92815962825, 17996.0311682222],
    [0.00000000148, 3.02542567608, 1551.045222648],
    [0.00000000121, 0.05537321071, 13095.8426650774],
    [0.0000000012, 5.91904349732, 6206.8097787158],
    [0.00000000134, 3.11122937825, 21954.15760939799],
    [0.00000000119, 5.52143897201, 709.9330485583],
    [0.00000000122, 3.00840036775, 19800.9459562248],
    [0.00000000127, 1.37534182407, 14945.3161735544],
    [0.00000000141, 2.56886299638, 1052.2683831884],
    [0.00000000123, 2.83671175442, 11919.140866668],
    [0.00000000118, 0.81918292547, 5331.3574437408],
    [0.00000000151, 2.68728567951, 11769.8536931664],
    [0.00000000119, 5.08654046247, 5481.2549188676],
    [0.00000000113, 4.42675663942, 18422.62935909819],
    [0.00000000153, 2.46021790779, 11933.3679606696],
    [0.00000000108, 1.04936452151, 11403.676995575],
    [0.00000000128, 0.99810456461, 8827.3902698748],
    [0.00000000144, 2.54869747042, 227.476132789],
    [0.0000000015, 4.50631437136, 2379.1644735716],
    [0.00000000109, 0.29269062317, 16737.5772365966],
    [0.00000000122, 4.23040027813, 29.429508536],
    [0.00000000111, 5.16970710025, 17782.7320727842],
    [0.00000000105, 1.61738153441, 13119.72110282519],
    [0.000000001, 3.52204690579, 18052.9295431578],
    [0.00000000108, 1.08493117155, 16858.4825329332],
    [0.00000000135, 3.2016061697, 6262.300454499],
    [0.00000000106, 1.96085069786, 74.7815985673],
    [0.00000000129, 4.85949366504, 16496.3613962024],
    [0.0000000011, 2.30605777952, 16460.33352952499],
    [0.00000000097, 3.5091894021, 5333.9002410216],
    [0.00000000099, 3.56417337974, 735.8765135318],
    [0.00000000096, 3.40918487598, 15720.8387848784],
    [0.00000000094, 5.01601027363, 3128.3887650958],
    [0.00000000097, 1.65579893894, 533.2140834436],
    [0.00000000092, 0.89219199493, 29296.6153895786],
    [0.00000000123, 3.16062062663, 9380.9596727172],
    [0.00000000102, 1.20493500565, 23020.65308658799],
    [0.00000000088, 2.21265504437, 12721.572099417],
    [0.00000000089, 1.5432266957, 20199.094959633],
    [0.00000000121, 6.19860353182, 9388.0059094152],
    [0.00000000089, 4.08082274765, 22805.7355659936],
    [0.00000000098, 1.09176668094, 12043.574281889],
    [0.00000000086, 1.13649001466, 143571.32428481648],
    [0.00000000088, 5.96980472191, 107.6635239386],
    [0.00000000082, 5.01561173481, 22003.9146348698],
    [0.00000000094, 1.69615700473, 23006.42599258639],
    [0.00000000081, 3.00664741995, 2118.7638603784],
    [0.00000000098, 1.39215287161, 8662.240323563],
    [0.0000000008, 5.16340988714, 17796.9591667858],
    [0.00000000082, 5.86893959287, 2787.0430238574],
    [0.00000000077, 0.80723694712, 167283.76158766549],
    [0.00000000091, 5.74902425304, 21424.4666443034],
    [0.00000000076, 5.67183650604, 14.2270940016],
    [0.00000000081, 6.16619455699, 1039.0266107904],
    [0.00000000076, 3.21449884756, 111.1866422876],
    [0.00000000078, 1.37531518377, 21947.1113727],
    [0.00000000074, 3.58814195051, 11609.8625440122],
    [0.00000000077, 4.84846488388, 22743.4093795164],
    [0.0000000009, 1.48869013606, 15671.0817594066],
    [0.00000000082, 3.48618398216, 29088.811415985],
    [0.00000000071, 2.2159156119, 12029.3471878874],
    [0.00000000069, 1.93625656075, 135.62532501],
    [0.0000000007, 2.66552760898, 18875.525869774],
    [0.00000000069, 5.41478093731, 26735.9452622132],
    [0.00000000079, 5.15158156951, 12323.4230960088],
    [0.00000000078, 4.17014063638, 1066.49547719],
    [0.00000000065, 5.64584720343, 12139.5535091068],
    [0.00000000071, 3.89804774037, 22779.4372461938],
    [0.00000000063, 4.53968787714, 8982.810669309],
    [0.00000000076, 3.29088891716, 2942.4634232916],
    [0.00000000069, 0.94232113005, 14919.0178537546],
    [0.00000000063, 4.0918653549, 16062.1845261168],
    [0.00000000065, 3.34580407184, 51.28033786241],
    [0.00000000065, 5.75757544877, 52670.0695933026],
    [0.00000000057, 5.25050277534, 20995.3929664494],
    [0.00000000061, 1.92290673861, 6805.6532680852],
    [0.00000000061, 0.08878901558, 13362.4497067992],
    [0.00000000076, 1.86947679415, 25287.7237993998],
    [0.00000000056, 4.25396542622, 6709.6740408674],
    [0.00000000058, 4.79429715781, 6286.3622074092],
    [0.00000000073, 0.53299090807, 2301.58581590939],
    [0.0000000007, 4.31243357502, 19402.7969528166],
    [0.00000000067, 2.53852336668, 377.3736079158],
    [0.00000000056, 3.20816844695, 24889.5747959916],
    [0.00000000054, 5.17336469511, 26084.0218062162],
    [0.00000000053, 3.17675406016, 18451.07854656599],
    [0.00000000053, 3.61529270216, 77.673770428],
    [0.00000000053, 0.45467549335, 30666.1549584328],
    [0.00000000053, 2.97761644192, 21548.9623692918],
    [0.00000000061, 0.14805728543, 23013.5395395872],
    [0.00000000051, 3.32803972907, 56.8983749356],
    [0.00000000052, 3.41304011355, 23141.5583829246],
    [0.00000000058, 3.13638677202, 309.2783226558],
    [0.00000000054, 1.60896548545, 13341.6743113068],
    [0.00000000053, 5.81426394852, 16193.65917750039],
    [0.00000000067, 6.27917920454, 22345.2603761082],
    [0.0000000005, 0.42577644151, 25685.872802808],
    [0.00000000048, 0.70204553352, 1162.4747044078],
    [0.00000000066, 3.64350022359, 15265.8865193004],
    [0.0000000005, 5.7438291744, 19.66976089979],
    [0.00000000054, 1.97277370837, 23581.2581773176],
    [0.00000000051, 1.23713196525, 12539.853380183],
    [0.00000000046, 5.41431704639, 33019.0211122046],
    [0.00000000046, 4.80640843261, 19651.048481098],
    [0.0000000005, 1.23847511223, 22476.73502749179],
    [0.00000000051, 4.91913434178, 12592.4500197826],
    [0.00000000046, 2.41369976086, 98068.53671630539],
    [0.00000000045, 3.45227074337, 30774.5016425748],
    [0.00000000045, 4.39659083856, 433.7117378768],
    [0.00000000045, 3.71921056816, 18209.33026366019],
    [0.00000000044, 2.47683925106, 24356.7807886416],
    [0.00000000049, 2.17835058609, 13521.7514415914],
    [0.00000000046, 0.26142733448, 11.0457002639],
    [0.00000000045, 2.46230645202, 51868.2486621788],
    [0.00000000043, 4.29458463014, 28230.18722269139],
    [0.00000000048, 0.89551707131, 56600.2792895222],
    [0.00000000042, 3.63410684699, 4590.910180489],
    [0.00000000049, 3.17757670967, 6303.8512454838],
    [0.00000000043, 4.93350349236, 10021.8372800994],
    [0.00000000052, 3.65410195699, 7872.1487452752],
    [0.00000000041, 4.82166756935, 10988.808157535],
    [0.0000000004, 1.81891629936, 34596.3646546524],
    [0.00000000043, 1.94164978061, 1903.4368125012],
    [0.00000000041, 0.74461854136, 23937.856389741],
    [0.00000000045, 5.4557501753, 60530.4889857418],
    [0.0000000005, 5.67355640472, 18216.443810661],
    [0.0000000004, 0.04502010161, 38526.574350872],
    [0.00000000053, 3.64807615995, 11925.2740926006],
    [0.00000000042, 5.19292937193, 19004.6479494084],
    [0.00000000041, 0.94309683296, 9924.8104215106],
    [0.00000000039, 4.61184303844, 95.9792272178],
    [0.00000000049, 2.05532526216, 12573.2652469836],
    [0.00000000045, 3.73717824543, 7875.6718636242],
    [0.00000000043, 1.14078465002, 49.7570254718],
    [0.00000000039, 1.70539366023, 32217.2001810808],
    [0.00000000037, 1.29390383811, 310.8407988684],
    [0.00000000038, 0.9597092595, 664.75604513],
    [0.00000000039, 0.85957361635, 16522.6597160022],
    [0.0000000004, 1.00170796001, 36949.2308084242],
    [0.0000000004, 3.78164718776, 55798.4583583984],
    [0.00000000037, 5.42237070904, 6286.6662786432],
    [0.00000000036, 1.68167662194, 10344.2950653858],
    [0.0000000004, 5.13217319067, 15664.03552270859],
    [0.00000000049, 3.62741283878, 77713.7714681205],
    [0.00000000045, 6.15877872538, 28286.9904848612],
    [0.00000000036, 3.32158458257, 16207.886271502],
    [0.00000000035, 5.83917764292, 6321.1035226272],
    [0.00000000036, 1.80784164083, 6279.7894925736],
    [0.00000000035, 4.60279245362, 28237.2334593894],
    [0.00000000033, 0.47301775923, 18635.9284545362],
    [0.00000000035, 4.36571027474, 48739.859897083],
    [0.00000000031, 3.06828028412, 6819.8803620868],
    [0.00000000031, 2.4020319848, 28628.3362260996],
    [0.00000000034, 1.90096411242, 12964.300703391],
    [0.00000000029, 6.09291010354, 18606.4989460002],
    [0.00000000028, 3.42046112698, 6288.5987742988],
    [0.00000000028, 3.437361406, 34115.1140692746],
    [0.00000000029, 1.48920816078, 6489.2613984286],
    [0.00000000028, 3.07474749886, 29822.7832363242],
    [0.00000000038, 2.44608264663, 31415.379249957],
    [0.00000000028, 2.98392582088, 6277.552925684],
    [0.00000000027, 5.03556015623, 12779.4507954208],
    [0.00000000027, 5.40812977287, 26087.9031415742],
    [0.00000000038, 5.56439937893, 27832.0382192832],
    [0.00000000026, 3.87685883153, 6262.7205305926],
    [0.00000000027, 6.1556539284, 28759.81087748319],
    [0.00000000025, 5.17122153205, 6915.8595893046],
    [0.00000000027, 4.03132006944, 9910.583327509],
    [0.00000000033, 3.97763407373, 12410.7313005486],
    [0.00000000024, 5.31307120044, 29026.48522950779],
    [0.00000000025, 0.81055213297, 36173.7081971002],
    [0.00000000024, 1.2870610131, 24491.4257925834],
    [0.00000000021, 2.02548478742, 28766.924424484],
    [0.00000000021, 6.07545114034, 18139.2945014159],
    [0.00000000022, 2.31199937131, 6303.4311693902],
    [0.00000000023, 1.35235057478, 49515.382508407],
    [0.00000000023, 2.92765926961, 65236.2212932854],
    [0.00000000019, 0.03636659763, 29864.334027309],
    [0.0000000002, 0.91374066194, 45585.1728121874],
    [0.00000000021, 4.45003013294, 22490.9621214934],
    [0.00000000022, 1.97119365888, 34513.2630726828],
    [0.0000000002, 4.11682669951, 17157.0618804718],
    [0.00000000024, 1.40243942415, 14712.317116458],
    [0.00000000022, 2.19759737115, 31570.7996493912],
    [0.00000000021, 1.48739821208, 61306.0115970658],
    [0.00000000025, 5.71465573409, 25934.1243310894],
];

const VSOP87_L2: Vsop87Element = [
    [0.00008721859, 1.07253635559, 6283.0758499914],
    [0.0000099099, Math.PI],
    [0.00000294833, 0.43717350256, 12566.1516999828],
    [0.00000027338, 0.05295636147, 3.523118349],
    [0.00000016333, 5.18820215724, 26.2983197998],
    [0.00000015745, 3.68504712183, 155.4203994342],
    [0.00000009425, 0.29667114694, 18849.2275499742],
    [0.00000008938, 2.05706319592, 77713.7714681205],
    [0.0000000694, 0.82691541038, 775.522611324],
    [0.00000005061, 4.6624323168, 1577.3435424478],
    [0.0000000406, 1.03067032318, 7.1135470008],
    [0.00000003464, 5.14021224609, 796.2980068164],
    [0.00000003172, 6.05479318507, 5507.5532386674],
    [0.0000000302, 1.19240008524, 242.728603974],
    [0.00000002885, 6.11705865396, 529.6909650946],
    [0.00000003809, 3.44043369494, 5573.1428014331],
    [0.00000002719, 0.30363248164, 398.1490034082],
    [0.00000002365, 4.37666117992, 5223.6939198022],
    [0.00000002538, 2.27966434314, 553.5694028424],
    [0.00000002078, 3.75435095487, 0.9803210682],
    [0.00000001675, 0.90149951436, 951.7184062506],
    [0.00000001534, 5.75895831192, 1349.8674096588],
    [0.00000001224, 2.97285792195, 2146.1654164752],
    [0.00000001449, 4.36401639552, 1748.016413067],
    [0.00000001341, 3.72019379666, 1194.4470102246],
    [0.00000001253, 2.9488872631, 6438.4962494256],
    [0.00000000999, 5.98665341008, 6286.5989683404],
    [0.00000000917, 4.79722195184, 5088.6288397668],
    [0.00000000829, 3.31021398862, 213.299095438],
    [0.00000001102, 1.27094359244, 161000.6857376741],
    [0.00000000764, 3.41231607038, 5486.777843175],
    [0.00000001046, 0.60374190029, 3154.6870848956],
    [0.00000000887, 5.23364022595, 7084.8967811152],
    [0.00000000644, 1.59974355582, 2544.3144198834],
    [0.00000000681, 3.42742947469, 4694.0029547076],
    [0.00000000606, 2.47688996663, 10977.078804699],
    [0.00000000706, 6.19369692903, 4690.4798363586],
    [0.00000000643, 1.98119869589, 801.8209311238],
    [0.00000000502, 1.44415463861, 6836.6452528338],
    [0.0000000049, 2.33889753806, 1592.5960136328],
    [0.00000000458, 1.30867922972, 4292.3308329504],
    [0.00000000431, 0.03542536476, 7234.794256242],
    [0.00000000349, 0.98779272263, 6040.3472460174],
    [0.00000000385, 1.57065592218, 71430.69561812909],
    [0.00000000371, 3.16149051601, 6309.3741697912],
    [0.00000000348, 0.64980950594, 1059.3819301892],
    [0.00000000458, 3.81505682017, 149854.40013480789],
    [0.00000000302, 1.91723873447, 10447.3878396044],
    [0.00000000306, 3.55405857884, 8031.0922630584],
    [0.00000000395, 4.93742673052, 7632.9432596502],
    [0.00000000314, 3.18058352846, 2352.8661537718],
    [0.00000000281, 4.41751404023, 9437.762934887],
    [0.00000000276, 2.71075791682, 3894.1818295422],
    [0.00000000298, 2.52045757001, 6127.6554505572],
    [0.00000000272, 0.24370191144, 25132.3033999656],
    [0.00000000251, 0.55449375765, 6279.5527316424],
    [0.00000000224, 1.40790249012, 4705.7323075436],
    [0.00000000258, 5.29510765044, 6812.766815086],
    [0.00000000178, 0.92636669742, 1990.745017041],
    [0.00000000217, 0.68543630022, 6256.7775301916],
    [0.00000000154, 0.77808632062, 14143.4952424306],
    [0.0000000015, 2.40636982736, 426.598190876],
    [0.00000000196, 6.06877865012, 640.8776073822],
    [0.00000000137, 2.21947617717, 8429.2412664666],
    [0.00000000127, 5.47380312768, 12036.4607348882],
    [0.00000000121, 3.32740512021, 17789.845619785],
    [0.00000000123, 2.16004509785, 10213.285546211],
    [0.00000000116, 0.49705139709, 7058.5984613154],
    [0.00000000138, 2.36181661472, 11506.7697697936],
    [0.00000000101, 0.86299995919, 6290.1893969922],
    [0.00000000118, 5.82317768355, 7860.4193924392],
    [0.00000000092, 5.11639978593, 7079.3738568078],
    [0.00000000125, 2.65424538513, 88860.05707098669],
    [0.00000000088, 4.3118823616, 83996.84731811189],
    [0.00000000084, 3.57682769713, 16730.4636895958],
    [0.00000000097, 5.58011309774, 13367.9726311066],
    [0.00000000102, 2.05853060226, 87.30820453981],
    [0.0000000008, 4.73827128421, 11926.2544136688],
    [0.0000000008, 5.41344057121, 10973.55568635],
    [0.00000000106, 4.10978997399, 3496.032826134],
    [0.00000000075, 4.89166898876, 5643.1785636774],
    [0.000000001, 3.62645659087, 244287.60000722769],
    [0.00000000096, 1.39443577787, 6681.2248533996],
    [0.00000000069, 1.88399189965, 10177.2576795336],
    [0.00000000087, 0.40842153208, 11015.1064773348],
    [0.00000000066, 0.99444831932, 6525.8044539654],
    [0.00000000066, 1.42471816453, 9917.6968745098],
    [0.00000000067, 5.5124099707, 3097.88382272579],
    [0.00000000076, 2.7156469351, 4164.311989613],
    [0.00000000085, 0.4965552367, 10575.4066829418],
    [0.00000000077, 3.51693861509, 11856.2186514245],
    [0.00000000062, 3.6258762869, 16496.3613962024],
    [0.00000000054, 5.25957420065, 3340.6124266998],
    [0.00000000053, 1.10902178415, 8635.9420037632],
    [0.00000000049, 5.65761054625, 20426.571092422],
    [0.00000000064, 5.79211164779, 2388.8940204492],
    [0.00000000046, 5.45092696155, 6275.9623029906],
    [0.00000000057, 4.97077155798, 14945.3161735544],
    [0.00000000043, 3.30685683359, 9779.1086761254],
    [0.00000000042, 1.61412785248, 12168.0026965746],
    [0.00000000049, 3.92715473768, 5729.506447149],
    [0.00000000042, 0.6348125893, 2699.7348193176],
    [0.00000000056, 4.34038639086, 90955.5516944961],
    [0.0000000004, 5.66871428338, 11712.9553182308],
    [0.00000000039, 3.10911294009, 16200.7727245012],
    [0.0000000004, 5.71338386146, 709.9330485583],
    [0.00000000053, 6.17067257683, 233141.31440436149],
    [0.00000000037, 0.32095173508, 24356.7807886416],
    [0.00000000035, 0.95557073457, 17298.1823273262],
    [0.00000000035, 0.64913397996, 25158.6017197654],
    [0.00000000041, 1.53850422484, 65147.6197681377],
    [0.00000000035, 0.77655626359, 13916.0191096416],
    [0.00000000031, 5.35897350775, 5331.3574437408],
    [0.0000000003, 4.48114682755, 23543.23050468179],
    [0.00000000032, 3.45976963453, 7477.522860216],
    [0.00000000029, 3.46648040769, 13119.72110282519],
    [0.00000000038, 2.90863974625, 12721.572099417],
    [0.00000000029, 3.13390968321, 4136.9104335162],
    [0.00000000035, 3.79717126309, 143571.32428481648],
    [0.00000000027, 0.95726093828, 12559.038152982],
    [0.00000000026, 4.9532687703, 5753.3848848968],
    [0.00000000032, 3.49943896928, 6284.0561710596],
    [0.00000000026, 4.59276256636, 5884.9268465832],
    [0.00000000026, 1.53958920253, 154717.60988768269],
    [0.00000000023, 4.88012908735, 13095.8426650774],
    [0.00000000023, 0.35935706511, 31415.379249957],
    [0.00000000024, 5.11515116629, 18319.5365848796],
    [0.00000000021, 5.73872879912, 12569.6748183318],
    [0.00000000021, 1.32901200081, 10988.808157535],
    [0.00000000019, 2.24263229491, 18073.7049386502],
    [0.00000000019, 3.14253175605, 6496.3749454294],
    [0.00000000021, 2.80122025076, 6282.0955289232],
    [0.00000000023, 0.14288760398, 6283.0085396886],
    [0.00000000019, 4.28209473754, 3930.2096962196],
    [0.00000000016, 0.25933207663, 11790.6290886588],
    [0.00000000015, 6.0962350124, 13517.8701062334],
    [0.0000000002, 5.06358906224, 6283.14316029419],
    [0.00000000015, 1.0768066315, 4933.2084403326],
    [0.00000000019, 5.74000581249, 3128.3887650958],
    [0.00000000016, 6.18924226747, 7342.4577801806],
    [0.00000000013, 1.69105044945, 4535.0594369244],
    [0.00000000015, 3.36968394452, 17260.1546546904],
    [0.0000000001, 3.78885035015, 22003.9146348698],
    [0.00000000011, 2.12851973876, 7875.6718636242],
];

const VSOP87_L3: Vsop87Element = [
    [0.00000289058, 5.84173149732, 6283.0758499914],
    [0.00000020712, 6.0498393902, 12566.1516999828],
    [0.00000002962, 5.1956057957, 155.4203994342],
    [0.00000002527, Math.PI],
    [0.00000001288, 4.7219761197, 3.523118349],
    [0.00000000635, 5.96904899168, 242.728603974],
    [0.0000000057, 5.54182903238, 18849.2275499742],
    [0.00000000402, 3.78606612895, 553.5694028424],
    [0.00000000072, 4.37131884946, 6286.5989683404],
    [0.00000000067, 0.91133898967, 6127.6554505572],
    [0.00000000037, 5.28611190997, 6438.4962494256],
    [0.00000000021, 2.94917211527, 6309.3741697912],
    [0.00000000015, 3.63037493932, 71430.69561812909],
    [0.00000000011, 4.83261533939, 25132.3033999656],
    [0.00000000011, 5.84259014283, 6525.8044539654],
    [0.00000000012, 3.82296977522, 7058.5984613154],
    [0.00000000013, 2.39991715131, 5729.506447149],
    [0.00000000008, 0.55390332094, 6040.3472460174],
    [0.00000000008, 1.46298993048, 11856.2186514245],
    [0.00000000008, 5.07535888338, 6256.7775301916],
    [0.00000000006, 2.88803526743, 5507.5532386674],
    [0.00000000005, 3.87019253131, 12036.4607348882],
    [0.00000000005, 2.70838853362, 83996.84731811189],
];

const VSOP87_L4: Vsop87Element = [
    [0.00000007714, 4.14117321449, 6283.0758499914],
    [0.00000001016, 3.27573644241, 12566.1516999828],
    [0.0000000042, 0.41892851415, 155.4203994342],
    [0.00000000047, 3.50591071186, 18849.2275499742],
    [0.00000000041, 3.14032562331, 3.523118349],
    [0.00000000035, 5.0111077, 5573.1428014331],
    [0.0000000001, 5.64816633449, 6127.6554505572],
    [0.00000000013, 0.48609240774, 77713.7714681205],
    [0.00000000007, 2.84139222289, 161000.6857376741],
    [0.00000000004, 3.6550904707, 25132.3033999656],
    [0.00000000002, 0.54880603487, 6438.4962494256],
];

const VSOP87_L5: Vsop87Element = [
    [0.00000000172, 2.74854172392, 6283.0758499914],
    [0.0000000005, 2.01352986713, 155.4203994342],
    [0.00000000028, 2.93369985477, 12566.1516999828],
    [0.00000000005, 1.93829214518, 18849.2275499742],
];

const VSOP87_B0: Vsop87Element = [
    [0.0000027962, 3.19870156017, 84334.66158130829],
    [0.00000101643, 5.42248619256, 5507.5532386674],
    [0.00000080445, 3.88013204458, 5223.6939198022],
    [0.00000043806, 3.70444689759, 2352.8661537718],
    [0.00000031933, 4.00026369781, 1577.3435424478],
    [0.00000022724, 3.9847383156, 1047.7473117547],
    [0.00000016392, 3.56456119782, 5856.4776591154],
    [0.00000018141, 4.98367470262, 6283.0758499914],
    [0.00000014443, 3.70275614915, 9437.762934887],
    [0.00000014304, 3.41117857526, 10213.285546211],
    [0.00000011246, 4.82820690527, 14143.4952424306],
    [0.000000109, 2.08574562329, 6812.766815086],
    [0.00000009714, 3.47303947751, 4694.0029547076],
    [0.00000010367, 4.05663927945, 71092.88135493269],
    [0.00000008775, 4.44016515666, 5753.3848848968],
    [0.00000008366, 4.99251512183, 7084.8967811152],
    [0.00000006921, 4.32559054073, 6275.9623029906],
    [0.00000009145, 1.14182646613, 6620.8901131878],
    [0.00000007194, 3.60193205744, 529.6909650946],
    [0.00000007698, 5.55425745881, 167621.57585086189],
    [0.00000005285, 2.48446991536, 4705.7323075436],
    [0.00000005208, 6.24992674532, 18073.7049386502],
    [0.00000004529, 2.33827747356, 6309.3741697912],
    [0.00000005579, 4.41023653719, 7860.4193924392],
    [0.00000004743, 0.70995680136, 5884.9268465832],
    [0.00000004301, 1.10255777773, 6681.2248533996],
    [0.00000003849, 1.82229412532, 5486.777843175],
    [0.00000004093, 5.11700141197, 13367.9726311066],
    [0.00000003681, 0.43793170336, 3154.6870848956],
    [0.0000000342, 5.42034800952, 6069.7767545534],
    [0.00000003617, 6.04641937568, 3930.2096962196],
    [0.0000000367, 4.58210192227, 12194.0329146209],
    [0.00000002918, 1.95463881136, 10977.078804699],
    [0.00000002797, 5.61259274877, 11790.6290886588],
    [0.00000002502, 0.60499729368, 6496.3749454294],
    [0.00000002319, 5.01648216088, 1059.3819301892],
    [0.00000002684, 1.39470396487, 22003.9146348698],
    [0.00000002428, 3.24183056545, 78051.5857313169],
    [0.0000000212, 4.30691000285, 5643.1785636774],
    [0.00000002257, 3.15557225087, 90617.7374312997],
    [0.00000001813, 3.75574218286, 3340.6124266998],
    [0.00000002226, 2.79699346673, 12036.4607348882],
    [0.00000001888, 0.86991545944, 8635.9420037632],
    [0.00000001517, 1.9585205571, 398.1490034082],
    [0.00000001581, 3.19976230948, 5088.6288397668],
    [0.00000001421, 6.25530883828, 2544.3144198834],
    [0.00000001595, 0.25619915132, 17298.1823273262],
    [0.00000001391, 4.69964175574, 7058.5984613154],
    [0.00000001478, 2.81808207569, 25934.1243310894],
    [0.00000001481, 3.6582355461, 11506.7697697936],
    [0.00000001693, 4.95689385293, 156475.2902479957],
    [0.00000001183, 1.29343060777, 775.522611324],
    [0.00000001114, 2.37889311847, 3738.761430108],
    [0.00000000994, 4.30088900425, 9225.539273283],
    [0.00000000924, 3.06451026809, 4164.311989613],
    [0.00000000867, 0.55606931068, 8429.2412664666],
    [0.00000000988, 5.97286104208, 7079.3738568078],
    [0.00000000824, 1.50984806177, 10447.3878396044],
    [0.00000000915, 0.12635654605, 11015.1064773348],
    [0.00000000742, 1.99159139281, 26087.9031415742],
    [0.00000001039, Math.PI],
    [0.0000000085, 4.24120016095, 29864.334027309],
    [0.00000000755, 2.89631873314, 4732.0306273434],
    [0.00000000714, 1.37548118605, 2146.1654164752],
    [0.00000000708, 1.91406542362, 8031.0922630584],
    [0.00000000746, 0.57893808622, 796.2980068164],
    [0.00000000802, 5.12339137235, 2942.4634232916],
    [0.00000000751, 1.67479850166, 21228.3920235458],
    [0.00000000602, 4.099765389, 64809.80550494129],
    [0.00000000594, 3.49580704849, 16496.3613962024],
    [0.00000000592, 4.59481504319, 4690.4798363586],
    [0.0000000053, 5.73979295194, 8827.3902698748],
    [0.00000000503, 5.66433137112, 33794.5437235286],
    [0.00000000483, 1.57106522322, 801.8209311238],
    [0.00000000438, 0.0670773372, 3128.3887650958],
    [0.00000000423, 2.86944596145, 12566.1516999828],
    [0.00000000504, 3.2620766916, 7632.9432596502],
    [0.00000000552, 1.02926440457, 239762.20451754928],
    [0.00000000427, 3.67434378208, 213.299095438],
    [0.00000000404, 1.4619329736, 15720.8387848784],
    [0.00000000503, 4.85802444134, 6290.1893969922],
    [0.00000000417, 0.81920713533, 5216.5803728014],
    [0.00000000365, 0.01002966145, 12168.0026965746],
    [0.00000000363, 1.28376436579, 6206.8097787158],
    [0.00000000353, 4.7005913311, 7234.794256242],
    [0.00000000415, 0.96862624176, 4136.9104335162],
    [0.00000000387, 3.09145061418, 25158.6017197654],
    [0.00000000373, 2.65119262808, 7342.4577801806],
    [0.00000000361, 2.97762937735, 9623.6882766912],
    [0.00000000418, 3.75759994446, 5230.807466803],
    [0.00000000396, 1.22507712354, 6438.4962494256],
    [0.00000000322, 1.21162178805, 8662.240323563],
    [0.00000000284, 5.64170320179, 1589.0728952838],
    [0.00000000379, 1.72248432756, 14945.3161735544],
    [0.0000000032, 3.94161159658, 7330.8231617461],
    [0.00000000313, 5.47602376451, 1194.4470102246],
    [0.00000000292, 1.38971327568, 11769.8536931664],
    [0.00000000305, 0.80429352049, 37724.7534197482],
    [0.00000000257, 5.81382810029, 426.598190876],
    [0.00000000265, 6.10358507671, 6836.6452528338],
    [0.0000000025, 4.56452895547, 7477.522860216],
    [0.00000000266, 2.62926282354, 7238.6755916],
    [0.00000000263, 6.22089501237, 6133.5126528568],
    [0.00000000306, 2.79682380532, 1748.016413067],
    [0.00000000236, 2.46093023707, 11371.7046897582],
    [0.00000000316, 1.62662805006, 250908.49012041549],
    [0.00000000216, 3.68721275185, 5849.3641121146],
    [0.0000000023, 0.36165162947, 5863.5912061162],
    [0.00000000233, 5.03509933618, 20426.571092422],
    [0.000000002, 5.86073159059, 4535.0594369244],
    [0.00000000277, 4.65400292395, 82239.16695779889],
    [0.00000000209, 3.72323200803, 10973.55568635],
    [0.00000000199, 5.05186622555, 5429.8794682394],
    [0.00000000256, 2.40923279886, 19651.048481098],
    [0.0000000021, 4.50691909144, 29088.811415985],
    [0.00000000181, 6.00294783127, 4292.3308329504],
    [0.00000000249, 0.12900984422, 154379.79562448629],
    [0.00000000209, 3.87759458541, 17789.845619785],
    [0.00000000225, 3.18339652605, 18875.525869774],
    [0.00000000191, 4.53897489216, 18477.1087646123],
    [0.00000000172, 2.0969418273, 13095.8426650774],
    [0.00000000182, 3.16107943487, 16730.4636895958],
    [0.00000000188, 2.22746128596, 41654.9631159678],
    [0.00000000164, 5.18686274999, 5481.2549188676],
    [0.0000000016, 2.4929885502, 12592.4500197826],
    [0.00000000155, 1.59595438224, 10021.8372800994],
    [0.00000000135, 0.21349051305, 10988.808157535],
    [0.00000000178, 3.80375178044, 23581.2581773176],
    [0.00000000123, 1.66800739151, 15110.4661198662],
    [0.00000000122, 2.72678272224, 18849.2275499742],
    [0.00000000126, 1.17675512872, 14919.0178537546],
    [0.00000000142, 3.95053440992, 337.8142631964],
    [0.00000000116, 6.06340906212, 6709.6740408674],
    [0.00000000137, 3.52143246244, 12139.5535091068],
    [0.00000000136, 2.92179113491, 32217.2001810808],
    [0.0000000011, 3.51203379263, 18052.9295431578],
    [0.00000000147, 4.63371971408, 22805.7355659936],
    [0.00000000108, 5.45280815225, 7.1135470008],
    [0.00000000148, 0.65447253687, 95480.9471841745],
    [0.00000000119, 5.92110458985, 33019.0211122046],
    [0.0000000011, 5.34824206403, 639.897286314],
    [0.00000000106, 3.71081682614, 14314.1681130498],
    [0.00000000139, 6.17607198262, 24356.7807886416],
    [0.00000000118, 5.59738712949, 161338.5000008705],
    [0.00000000117, 3.6506527164, 45585.1728121874],
    [0.00000000127, 4.74596574209, 49515.382508407],
    [0.0000000012, 1.04211499785, 6915.8595893046],
    [0.0000000012, 5.60638811846, 5650.2921106782],
    [0.00000000115, 3.10668213303, 14712.317116458],
    [0.00000000099, 0.6901893993, 12779.4507954208],
    [0.00000000097, 1.07908724794, 9917.6968745098],
    [0.00000000093, 2.62295197146, 17260.1546546904],
    [0.00000000099, 4.45774681732, 4933.2084403326],
    [0.00000000123, 1.37488921994, 28286.9904848612],
    [0.00000000121, 5.19767249869, 27511.4678735372],
    [0.00000000105, 0.87192268229, 77375.95720492408],
    [0.00000000087, 3.9363781295, 17654.7805397496],
    [0.00000000122, 2.2395606868, 83997.09113559539],
    [0.00000000087, 4.18201600921, 22779.4372461938],
    [0.00000000104, 4.59580877285, 1349.8674096588],
    [0.00000000102, 2.83545248595, 12352.8526045448],
    [0.00000000102, 3.97386522171, 10818.1352869158],
    [0.00000000101, 4.32892825818, 36147.4098773004],
    [0.00000000094, 5.00001709338, 150192.21439800429],
    [0.00000000077, 3.971993693, 1592.5960136328],
    [0.000000001, 6.07733097102, 26735.9452622132],
    [0.00000000086, 5.2602963825, 28313.288804661],
    [0.00000000093, 4.31900620254, 44809.6502008634],
    [0.00000000076, 6.22743405935, 13521.7514415914],
    [0.00000000072, 1.55820597747, 6256.7775301916],
    [0.00000000082, 4.95202664555, 10575.4066829418],
    [0.00000000082, 1.69647647075, 1990.745017041],
    [0.00000000075, 2.29836095644, 3634.6210245184],
    [0.00000000075, 2.66367876557, 16200.7727245012],
    [0.00000000087, 0.26630214764, 31441.6775697568],
    [0.00000000077, 2.25530952876, 5235.3285382367],
    [0.00000000076, 1.09869730334, 12903.9659631792],
    [0.00000000058, 4.28246137794, 12559.038152982],
    [0.00000000064, 5.51112829602, 173904.65170085328],
    [0.00000000056, 2.60133794851, 73188.3759784421],
    [0.00000000055, 5.81483150022, 143233.51002162008],
    [0.00000000054, 3.38482031504, 323049.11878710288],
    [0.00000000039, 3.28500401937, 71768.50988132549],
    [0.00000000039, 3.11239910096, 96900.81328129109],
];

const VSOP87_B1: Vsop87Element = [
    [0.00227777722, 3.4137662053, 6283.0758499914],
    [0.00003805678, 3.37063423795, 12566.1516999828],
    [0.00003619589],
    [0.00000071542, 3.32777549735, 18849.2275499742],
    [0.00000007655, 1.79489607186, 5223.6939198022],
    [0.00000008107, 3.89190403643, 5507.5532386674],
    [0.00000006456, 5.1978942475, 2352.8661537718],
    [0.00000003894, 2.15568517178, 6279.5527316424],
    [0.00000003892, 1.53021064904, 6286.5989683404],
    [0.00000003897, 4.87293945629, 10213.285546211],
    [0.00000003812, 1.43523182316, 12036.4607348882],
    [0.00000003577, 2.32913869227, 83996.84731811189],
    [0.0000000357, 4.92637739003, 71430.69561812909],
    [0.00000003494, 2.20864641831, 529.6909650946],
    [0.00000002421, 6.22876183393, 7860.4193924392],
    [0.00000002056, 3.06747139741, 14143.4952424306],
    [0.00000001399, 0.50107877909, 6309.3741697912],
    [0.00000001417, 3.28454570977, 25132.3033999656],
    [0.00000001544, 1.82062047625, 5856.4776591154],
    [0.00000001457, 1.75339303307, 5884.9268465832],
    [0.00000001497, 2.19673914456, 9437.762934887],
    [0.00000001549, 5.73650061398, 17789.845619785],
    [0.00000001277, 3.9672171733, 4705.7323075436],
    [0.00000001038, 2.9481870117, 6256.7775301916],
    [0.00000001018, 2.24114547164, 6681.2248533996],
    [0.00000001021, 1.4679502613, 11790.6290886588],
    [0.00000000916, 3.72965830745, 1059.3819301892],
    [0.00000001156, 6.04591336669, 398.1490034082],
    [0.0000000124, 0.77195902957, 6812.766815086],
    [0.00000001115, 3.92255876225, 12168.0026965746],
    [0.00000000908, 1.78447918237, 3930.2096962196],
    [0.00000000833, 0.09941579828, 11506.7697697936],
    [0.0000000079, 2.45555993228, 775.522611324],
    [0.00000000666, 4.40761401665, 5753.3848848968],
    [0.0000000052, 1.60179602491, 4694.0029547076],
    [0.00000000382, 0.26754532042, 1577.3435424478],
    [0.00000000405, 1.97558286872, 6283.0085396886],
    [0.00000000405, 1.53147989887, 6283.14316029419],
    [0.00000000388, 2.59563818411, 7058.5984613154],
    [0.00000000341, 3.61275156842, 13367.9726311066],
    [0.0000000028, 4.63052251735, 796.2980068164],
    [0.00000000276, 0.43350778219, 7079.3738568078],
    [0.00000000311, 5.28219636656, 17260.1546546904],
    [0.00000000275, 5.27597553634, 11769.8536931664],
    [0.00000000286, 2.98639716345, 6275.9623029906],
    [0.00000000251, 2.81315684448, 6290.1893969922],
    [0.00000000239, 5.77837903893, 10977.078804699],
    [0.00000000228, 0.14375973844, 3738.761430108],
    [0.00000000227, 2.51020991853, 7084.8967811152],
    [0.00000000211, 4.7202946547, 6496.3749454294],
    [0.00000000234, 3.1153527401, 709.9330485583],
    [0.00000000234, 0.5707581762, 11856.2186514245],
    [0.00000000237, 2.38791907394, 213.299095438],
    [0.00000000227, 1.12059781634, 12352.8526045448],
    [0.00000000169, 3.20148089605, 5486.777843175],
    [0.00000000159, 3.14604135756, 8827.3902698748],
    [0.0000000016, 1.14784478002, 5643.1785636774],
    [0.00000000144, 5.23285657431, 78051.5857313169],
    [0.00000000144, 1.16454654602, 90617.7374312997],
    [0.00000000144, 3.81203756929, 6262.300454499],
    [0.00000000143, 5.97809021355, 6303.8512454838],
    [0.00000000138, 4.29829933273, 1589.0728952838],
    [0.00000000161, 3.03298851492, 20426.571092422],
    [0.00000000165, 5.09134896587, 17298.1823273262],
    [0.00000000128, 4.41590143012, 6127.6554505572],
    [0.00000000158, 2.00984506334, 5230.807466803],
    [0.0000000013, 1.44170683802, 12569.6748183318],
    [0.00000000125, 1.69950379498, 3128.3887650958],
    [0.00000000152, 4.96946111415, 65147.6197681377],
    [0.00000000131, 4.24961399629, 6282.0955289232],
    [0.00000000131, 5.54051222995, 6284.0561710596],
    [0.00000000161, 3.32421999691, 6283.3196674749],
    [0.00000000123, 2.93221463795, 15720.8387848784],
    [0.00000000152, 1.56488157456, 18319.5365848796],
    [0.00000000114, 1.89110005546, 18073.7049386502],
    [0.00000000113, 4.95214866677, 4136.9104335162],
    [0.00000000111, 4.79699611405, 8429.2412664666],
    [0.00000000118, 3.06184958762, 22003.9146348698],
    [0.00000000128, 2.09693027395, 12562.6285816338],
    [0.00000000138, 0.84648544836, 6069.7767545534],
    [0.000000001, 0.41938790104, 5481.2549188676],
    [0.00000000101, 4.43791289246, 19651.048481098],
    [0.00000000116, 1.87002428935, 77713.7714681205],
    [0.00000000095, 0.68638183645, 3340.6124266998],
    [0.00000000104, 4.90822646457, 8635.9420037632],
    [0.00000000114, 0.36008214928, 23543.23050468179],
    [0.00000000091, 1.1761121931, 9225.539273283],
    [0.00000000091, 2.74682631104, 5216.5803728014],
    [0.00000000086, 3.09315282195, 1194.4470102246],
    [0.00000000093, 6.2764351319, 12559.038152982],
    [0.00000000087, 3.64926989547, 7.1135470008],
    [0.00000000083, 0.37008971174, 11371.7046897582],
    [0.00000000098, 4.68473306376, 167283.76158766549],
    [0.00000000098, 0.99865886857, 154717.60988768269],
    [0.00000000086, 4.41152307486, 25934.1243310894],
    [0.00000000098, 4.98209568932, 16496.3613962024],
    [0.00000000085, 2.35438163823, 3154.6870848956],
    [0.00000000083, 0.24859477658, 21228.3920235458],
    [0.00000000076, 5.46661600296, 29864.334027309],
    [0.00000000069, 3.22045334237, 801.8209311238],
    [0.00000000068, 2.19928242745, 37724.7534197482],
    [0.0000000007, 5.33711014698, 2544.3144198834],
    [0.00000000055, 5.37872238211, 11015.1064773348],
    [0.00000000051, 5.03600618727, 5863.5912061162],
    [0.00000000059, 3.54984809612, 4535.0594369244],
    [0.00000000053, 1.50812064137, 7342.4577801806],
    [0.00000000044, 1.33712241647, 4164.311989613],
    [0.00000000055, 5.38460045253, 7477.522860216],
    [0.00000000049, 5.61844340512, 24072.9214697764],
    [0.00000000057, 6.17973522898, 8031.0922630584],
    [0.00000000052, 4.24379064407, 5088.6288397668],
    [0.00000000041, 3.41960196246, 26087.9031415742],
    [0.00000000052, 1.68150981131, 25158.6017197654],
    [0.00000000053, 0.11041408311, 29088.811415985],
    [0.00000000043, 0.53354396923, 2146.1654164752],
    [0.0000000005, 0.60270799844, 33794.5437235286],
    [0.00000000045, 1.69577010458, 6702.5604938666],
    [0.00000000037, 6.09033460795, 64809.80550494129],
    [0.00000000044, 2.67993061247, 15110.4661198662],
    [0.00000000047, 3.62555676035, 41654.9631159678],
    [0.00000000036, 0.47219666269, 13095.8426650774],
    [0.00000000035, 5.99520523215, 23581.2581773176],
    [0.00000000043, 4.08726331262, 156137.47598479928],
    [0.00000000043, 5.17376496602, 18422.62935909819],
    [0.00000000034, 2.14460100274, 4933.2084403326],
    [0.0000000003, 4.12992793541, 426.598190876],
    [0.00000000036, 2.28596930002, 90279.92316810328],
    [0.00000000032, 0.81117747619, 26.2983197998],
    [0.00000000028, 4.07036560467, 14712.317116458],
    [0.00000000025, 1.92905243842, 1748.016413067],
    [0.00000000024, 5.06152880842, 16730.4636895958],
    [0.00000000023, 3.24047012195, 31415.379249957],
    [0.00000000027, 3.90672018305, 18451.07854656599],
    [0.00000000021, 3.51419811826, 10447.3878396044],
];

const VSOP87_B2: Vsop87Element = [
    [0.00009721424, 5.1519280992, 6283.0758499914],
    [0.00000233002, Math.PI],
    [0.00000134188, 0.64406212977, 12566.1516999828],
    [0.00000006504, 1.07333397797, 18849.2275499742],
    [0.00000001662, 1.62746869551, 84334.66158130829],
    [0.00000000635, 3.51985338656, 6279.5527316424],
    [0.00000000492, 2.41382223971, 1047.7473117547],
    [0.00000000307, 6.10181422085, 5223.6939198022],
    [0.00000000322, 0.37660897389, 6286.5989683404],
    [0.00000000326, 2.35727931602, 5507.5532386674],
    [0.00000000274, 1.65307581765, 7860.4193924392],
    [0.00000000228, 1.14082932988, 25132.3033999656],
    [0.00000000202, 0.4983668253, 2352.8661537718],
    [0.00000000201, 0.155527656, 10213.285546211],
    [0.00000000167, 3.98005254015, 529.6909650946],
    [0.0000000017, 5.28668290523, 6256.7775301916],
    [0.00000000166, 3.04613930284, 12036.4607348882],
    [0.00000000153, 4.06779216239, 83996.84731811189],
    [0.0000000015, 3.18772213951, 71430.69561812909],
    [0.0000000012, 3.13558669517, 5884.9268465832],
    [0.00000000123, 4.17102530625, 6309.3741697912],
    [0.000000001, 1.46356761368, 11506.7697697936],
    [0.000000001, 3.00322421365, 11790.6290886588],
    [0.00000000077, 1.65643898948, 4705.7323075436],
    [0.00000000068, 6.03791904123, 6812.766815086],
    [0.00000000075, 4.85191600582, 14143.4952424306],
    [0.00000000079, 4.12628805658, 5753.3848848968],
    [0.00000000064, 2.7194416046, 6127.6554505572],
    [0.00000000063, 0.78655326011, 6438.4962494256],
    [0.00000000075, 0.84213523741, 167621.57585086189],
    [0.00000000051, 4.55059044701, 5486.777843175],
    [0.0000000005, 5.29314320585, 7079.3738568078],
    [0.00000000045, 0.33147576416, 775.522611324],
    [0.00000000043, 3.6179371164, 1577.3435424478],
    [0.00000000057, 6.15295833679, 12194.0329146209],
    [0.00000000045, 1.18274698508, 17789.845619785],
    [0.00000000047, 1.11643162773, 398.1490034082],
    [0.00000000047, 5.5298423843, 12168.0026965746],
    [0.00000000042, 2.6437530062, 10988.808157535],
    [0.00000000037, 0.31226891972, 6681.2248533996],
    [0.00000000046, 3.38617099014, 156475.2902479957],
    [0.00000000033, 1.26266496002, 6290.1893969922],
    [0.00000000033, 2.25067065498, 6275.9623029906],
    [0.00000000027, 1.72859626293, 1059.3819301892],
    [0.00000000028, 2.88681054153, 796.2980068164],
    [0.0000000003, 5.52021264181, 7058.5984613154],
    [0.00000000021, 6.22275008403, 6069.7767545534],
    [0.00000000024, 5.83690442827, 6282.0955289232],
    [0.00000000024, 3.95322179797, 6284.0561710596],
    [0.00000000021, 4.87022458966, 3738.761430108],
    [0.00000000021, 3.58048145762, 6496.3749454294],
    [0.00000000022, 1.97770318395, 7.1135470008],
    [0.00000000019, 3.4597988877, 4136.9104335162],
    [0.00000000015, 2.81379880771, 1589.0728952838],
    [0.00000000015, 1.61313151838, 1194.4470102246],
    [0.00000000015, 0.63083434831, 11769.8536931664],
    [0.00000000019, 0.28082047767, 17260.1546546904],
    [0.00000000017, 1.35165136146, 78051.5857313169],
    [0.00000000015, 2.3094159956, 11856.2186514245],
    [0.00000000012, 1.12997370513, 90617.7374312997],
    [0.00000000012, 0.00611601597, 18073.7049386502],
    [0.00000000012, 1.70058636365, 12559.038152982],
];

const VSOP87_B3: Vsop87Element = [
    [0.00000275993, 0.59480097092, 6283.0758499914],
    [0.00000017034, Math.PI],
    [0.00000003617, 0.11750575325, 12566.1516999828],
    [0.00000000339, 5.66087461682, 18849.2275499742],
    [0.00000000056, 5.02765554835, 6279.5527316424],
    [0.00000000019, 5.99007646261, 6256.7775301916],
    [0.00000000018, 3.80004734567, 6309.3741697912],
    [0.00000000018, 1.21049250774, 6127.6554505572],
    [0.00000000018, 2.29734567137, 6438.4962494256],
    [0.00000000015, 4.72881467263, 6286.5989683404],
    [0.00000000012, 0.41481671808, 83996.84731811189],
    [0.00000000013, 5.54637369296, 25132.3033999656],
    [0.0000000001, 2.91937214232, 71430.69561812909],
    [0.00000000006, 2.1417324121, 11856.2186514245],
];

const VSOP87_B4: Vsop87Element = [
    [0.00000005745, 2.26734029843, 6283.0758499914],
    [0.0000000087],
    [0.00000000119, 4.26807972611, 12566.1516999828],
    [0.00000000017, 4.0742262044, 18849.2275499742],
    [0.00000000005, 0.84308705203, 1047.7473117547],
    [0.00000000005, 0.05711572303, 84334.66158130829],
];

const VSOP87_B5: Vsop87Element = [[0.00000000114, 4.31455980099, 6283.0758499914], [0.00000000024]];

const VSOP87_R0: Vsop87Element = [
    [1.00013988784],
    [0.01670699632, 3.09846350258, 6283.0758499914],
    [0.00013956024, 3.05524609456, 12566.1516999828],
    [0.0000308372, 5.19846674381, 77713.7714681205],
    [0.00001628463, 1.17387558054, 5753.3848848968],
    [0.00001575572, 2.84685214877, 7860.4193924392],
    [0.00000924799, 5.45292236722, 11506.7697697936],
    [0.00000542439, 4.56409151453, 3930.2096962196],
    [0.0000047211, 3.66100022149, 5884.9268465832],
    [0.0000032878, 5.89983686142, 5223.6939198022],
    [0.00000345969, 0.96368627272, 5507.5532386674],
    [0.00000306784, 0.29867139512, 5573.1428014331],
    [0.00000174844, 3.01193636733, 18849.2275499742],
    [0.00000243181, 4.2734953079, 11790.6290886588],
    [0.00000211836, 5.84714461348, 1577.3435424478],
    [0.0000018574, 5.02199710705, 10977.078804699],
    [0.00000109835, 5.0551063586, 5486.777843175],
    [0.00000098316, 0.88681311278, 6069.7767545534],
    [0.000000865, 5.68956418946, 15720.8387848784],
    [0.00000085831, 1.27079125277, 161000.6857376741],
    [0.00000062917, 0.92177053978, 529.6909650946],
    [0.00000057056, 2.01374292245, 83996.84731811189],
    [0.00000064908, 0.27251341435, 17260.1546546904],
    [0.00000049384, 3.24501240359, 2544.3144198834],
    [0.00000055736, 5.2415979917, 71430.69561812909],
    [0.0000004252, 6.01110257982, 6275.9623029906],
    [0.00000046966, 2.57799853213, 775.522611324],
    [0.00000038963, 5.36063832897, 4694.0029547076],
    [0.00000044666, 5.53715663816, 9437.762934887],
    [0.00000035661, 1.67447135798, 12036.4607348882],
    [0.00000031922, 0.18368299942, 5088.6288397668],
    [0.00000031846, 1.77775642078, 398.1490034082],
    [0.00000033193, 0.24370221704, 7084.8967811152],
    [0.00000038245, 2.39255343973, 8827.3902698748],
    [0.00000028468, 1.21344887533, 6286.5989683404],
    [0.00000037486, 0.82961281844, 19651.048481098],
    [0.00000036957, 4.90107587287, 12139.5535091068],
    [0.00000034537, 1.84270693281, 2942.4634232916],
    [0.00000026275, 4.58896863104, 10447.3878396044],
    [0.00000024596, 3.78660838036, 8429.2412664666],
    [0.00000023587, 0.26866098169, 796.2980068164],
    [0.00000027795, 1.89934427832, 6279.5527316424],
    [0.00000023927, 4.99598548145, 5856.4776591154],
    [0.00000020345, 4.65282190725, 2146.1654164752],
    [0.00000023287, 2.80783632869, 14143.4952424306],
    [0.00000022099, 1.95002636847, 3154.6870848956],
    [0.00000019509, 5.38233922479, 2352.8661537718],
    [0.00000017958, 0.1987136996, 6812.766815086],
    [0.00000017178, 4.43322156854, 10213.285546211],
    [0.0000001619, 5.23159323213, 17789.845619785],
    [0.00000017315, 6.15224075188, 16730.4636895958],
    [0.00000013814, 5.18962074032, 8031.0922630584],
    [0.00000018834, 0.67280058021, 149854.40013480789],
    [0.0000001833, 2.25348717053, 23581.2581773176],
    [0.00000013639, 3.68511810757, 4705.7323075436],
    [0.00000013142, 0.65267698994, 13367.9726311066],
    [0.00000010414, 4.33285688501, 11769.8536931664],
    [0.00000009978, 4.20126336356, 6309.3741697912],
    [0.0000001017, 1.59366684542, 4690.4798363586],
    [0.00000007564, 2.62560597391, 6256.7775301916],
    [0.00000009654, 3.67583728703, 27511.4678735372],
    [0.00000006743, 0.56269927047, 3340.6124266998],
    [0.00000008743, 6.06359123461, 1748.016413067],
    [0.00000007786, 3.67371235367, 12168.0026965746],
    [0.00000006633, 5.66149277789, 11371.7046897582],
    [0.00000007712, 0.31242577788, 7632.9432596502],
    [0.00000006586, 3.13580054586, 801.8209311238],
    [0.0000000746, 5.6475806666, 11926.2544136688],
    [0.00000006933, 2.92384586372, 6681.2248533996],
    [0.00000006805, 1.42327153767, 23013.5395395872],
    [0.00000006118, 5.13395999022, 1194.4470102246],
    [0.00000006477, 2.64986648493, 19804.8272915828],
    [0.00000005233, 4.62432817299, 6438.4962494256],
    [0.00000006147, 3.02863936662, 233141.31440436149],
    [0.00000004608, 1.72194702724, 7234.794256242],
    [0.00000004221, 1.55697533726, 7238.6755916],
    [0.0000000531, 2.40821524293, 11499.6562227928],
    [0.00000005128, 5.3239896569, 11513.8833167944],
    [0.0000000477, 0.2555431173, 11856.2186514245],
    [0.00000005519, 2.09089153789, 17298.1823273262],
    [0.00000005625, 4.34052903053, 90955.5516944961],
    [0.00000004578, 4.4656964157, 5746.271337896],
    [0.00000003788, 4.9072829481, 4164.311989613],
    [0.00000005337, 5.09957905103, 31441.6775697568],
    [0.00000003967, 1.20054555175, 1349.8674096588],
    [0.00000004005, 3.02853885902, 1059.3819301892],
    [0.0000000348, 0.76066308841, 10973.55568635],
    [0.00000004232, 1.05485713117, 5760.4984318976],
    [0.00000004582, 3.76570026763, 6386.16862421],
    [0.00000003335, 3.13829943354, 6836.6452528338],
    [0.0000000342, 3.00043974511, 4292.3308329504],
    [0.00000003595, 5.70703236079, 5643.1785636774],
    [0.00000003236, 4.16387400645, 9917.6968745098],
    [0.00000004154, 2.59940749519, 7058.5984613154],
    [0.00000003362, 4.54577164994, 4732.0306273434],
    [0.00000002978, 1.3056126882, 6283.14316029419],
    [0.00000002765, 0.51311975671, 26.2983197998],
    [0.00000002807, 5.66230537649, 8635.9420037632],
    [0.00000002927, 5.7378783408, 16200.7727245012],
    [0.00000003167, 1.691817599, 11015.1064773348],
    [0.00000002598, 2.96244118358, 25132.3033999656],
    [0.00000003519, 3.62639325753, 244287.60000722769],
    [0.00000002676, 4.20727719487, 18073.7049386502],
    [0.00000002978, 1.74971565805, 6283.0085396886],
    [0.00000002287, 1.06976449088, 14314.1681130498],
    [0.00000002863, 5.92838917309, 14712.317116458],
    [0.00000003071, 0.23793217, 35371.8872659764],
    [0.00000002656, 0.89959301615, 12352.8526045448],
    [0.00000002415, 2.799751768, 709.9330485583],
    [0.00000002811, 3.51513864541, 21228.3920235458],
    [0.00000001977, 2.61358297551, 951.7184062506],
    [0.00000002548, 2.47684686575, 6208.2942514241],
    [0.00000001999, 0.56090396506, 7079.3738568078],
    [0.00000002305, 1.05376463592, 22483.84857449259],
    [0.00000001855, 2.86093570752, 5216.5803728014],
    [0.00000002157, 1.31395211105, 154717.60988768269],
    [0.0000000197, 4.36931551625, 167283.76158766549],
    [0.00000001754, 2.14452400686, 6290.1893969922],
    [0.00000001628, 5.85704450617, 10984.1923516998],
    [0.00000002154, 6.03828353794, 10873.9860304804],
    [0.00000001714, 3.70158195222, 1592.5960136328],
    [0.00000001541, 6.21599512982, 23543.23050468179],
    [0.00000001602, 1.99860679677, 10969.9652576982],
    [0.00000001712, 1.34295218697, 3128.3887650958],
    [0.00000001647, 5.54948299069, 6496.3749454294],
    [0.00000001495, 5.43980459648, 155.4203994342],
    [0.00000001827, 5.91227480351, 3738.761430108],
    [0.00000001726, 2.16765465036, 10575.4066829418],
    [0.00000001532, 5.35683107063, 13521.7514415914],
    [0.00000001824, 1.66056145084, 39302.096962196],
    [0.00000001605, 1.90930973224, 6133.5126528568],
    [0.00000001282, 2.46013372544, 13916.0191096416],
    [0.00000001211, 4.4136063155, 3894.1818295422],
    [0.00000001394, 1.7780192925, 9225.539273283],
    [0.00000001571, 4.95512957606, 25158.6017197654],
    [0.00000001205, 1.19212756308, 3.523118349],
    [0.00000001132, 2.69830084955, 6040.3472460174],
    [0.00000001504, 5.77577388271, 18209.33026366019],
    [0.00000001393, 1.62625077326, 5120.6011455836],
    [0.00000001081, 2.93726744446, 17256.6315363414],
    [0.00000001232, 0.71651766504, 143571.32428481648],
    [0.00000001087, 0.99769687961, 955.5997416086],
    [0.00000001068, 5.28472576591, 65147.6197681377],
    [0.00000001169, 3.11663802316, 14945.3161735544],
    [0.00000000975, 5.1088726078, 6172.869528772],
    [0.00000001202, 4.02992510403, 553.5694028424],
    [0.00000000979, 2.00000879106, 15110.4661198662],
    [0.00000000962, 4.023807714, 6282.0955289232],
    [0.00000000999, 3.6264300279, 6262.300454499],
    [0.0000000103, 5.84987815239, 213.299095438],
    [0.00000001014, 2.84227679965, 8662.240323563],
    [0.00000001185, 1.51330629149, 17654.7805397496],
    [0.00000000967, 2.67081017562, 5650.2921106782],
    [0.00000001222, 2.65423784904, 88860.05707098669],
    [0.00000000986, 2.36212814824, 6206.8097787158],
    [0.00000001034, 0.13634950642, 11712.9553182308],
    [0.00000001103, 3.08477302937, 43232.3066584156],
    [0.00000000781, 2.53374971725, 16496.3613962024],
    [0.00000001019, 3.04569392376, 6037.244203762],
    [0.00000000795, 5.80662989126, 5230.807466803],
    [0.00000000813, 3.57702871938, 10177.2576795336],
    [0.00000000962, 5.31470594766, 6284.0561710596],
    [0.00000000717, 5.95797471837, 12559.038152982],
    [0.00000000967, 2.74413738053, 6244.9428143536],
    [0.00000000921, 0.1016016083, 29088.811415985],
    [0.00000000719, 5.91788189939, 4136.9104335162],
    [0.00000000688, 3.89489045092, 1589.0728952838],
    [0.00000000772, 4.05505380285, 6127.6554505572],
    [0.00000000706, 5.49323197725, 22003.9146348698],
    [0.00000000665, 1.60002747134, 11087.2851259184],
    [0.0000000069, 4.50539825729, 426.598190876],
    [0.00000000854, 3.2610464506, 20426.571092422],
    [0.00000000656, 4.3241018294, 16858.4825329332],
    [0.0000000084, 2.59572585212, 28766.924424484],
    [0.00000000686, 0.61944033771, 11403.676995575],
    [0.000000007, 3.40901412473, 7.1135470008],
    [0.00000000728, 0.04050185963, 5481.2549188676],
    [0.00000000653, 1.0386945123, 6062.6632075526],
    [0.00000000559, 4.79221805695, 20199.094959633],
    [0.00000000633, 5.70229959167, 45892.73043315699],
    [0.00000000591, 6.10986487621, 9623.6882766912],
    [0.0000000052, 3.62310356479, 5333.9002410216],
    [0.00000000602, 5.58381898589, 10344.2950653858],
    [0.00000000496, 2.21027756314, 1990.745017041],
    [0.00000000691, 1.96733114988, 12416.5885028482],
    [0.0000000064, 1.59062417043, 18319.5365848796],
    [0.00000000625, 3.82358168221, 13517.8701062334],
    [0.00000000475, 1.1702590418, 12569.6748183318],
    [0.0000000066, 5.08498512995, 283.8593188652],
    [0.00000000664, 4.50029469969, 47162.5163546352],
    [0.00000000569, 0.16318535463, 17267.26820169119],
    [0.00000000568, 3.86100969474, 6076.8903015542],
    [0.00000000462, 0.26368763517, 4590.910180489],
    [0.00000000535, 4.83225423196, 18422.62935909819],
    [0.00000000466, 0.75873879417, 7342.4577801806],
    [0.00000000541, 3.07212190556, 226858.23855437008],
    [0.0000000061, 1.53597089605, 33019.0211122046],
    [0.00000000617, 2.62356328726, 11190.377900137],
    [0.00000000548, 4.55798855803, 18875.525869774],
    [0.00000000633, 4.60110281228, 66567.48586525429],
    [0.00000000587, 5.78087907808, 632.7837393132],
    [0.00000000603, 5.38458554802, 316428.22867391503],
    [0.00000000525, 5.01522072363, 12132.439962106],
    [0.00000000469, 0.59975173763, 21954.15760939799],
    [0.00000000548, 3.50627043672, 17253.04110768959],
    [0.00000000502, 0.98804327589, 11609.8625440122],
    [0.00000000568, 1.98497313089, 7668.6374249425],
    [0.00000000482, 1.62460405687, 12146.6670561076],
    [0.00000000391, 3.68718382972, 18052.9295431578],
    [0.00000000457, 3.7721489661, 156137.47598479928],
    [0.00000000401, 5.2922154024, 15671.0817594066],
    [0.00000000469, 1.80963351735, 12562.6285816338],
    [0.00000000514, 3.37031288919, 20597.2439630412],
    [0.00000000452, 5.66811219778, 10454.5013866052],
    [0.00000000375, 4.98528185039, 9779.1086761254],
    [0.00000000523, 0.97215560834, 155427.54293624099],
    [0.00000000403, 5.1394818977, 1551.045222648],
    [0.00000000372, 3.69883738807, 9388.0059094152],
    [0.00000000367, 4.43875659833, 4535.0594369244],
    [0.00000000406, 4.20863156497, 12592.4500197826],
    [0.00000000362, 2.55099560446, 242.728603974],
    [0.00000000471, 4.61907324819, 5436.9930152402],
    [0.00000000388, 4.960209284, 24356.7807886416],
    [0.00000000441, 5.83872966262, 3496.032826134],
    [0.00000000349, 6.16307810648, 19800.9459562248],
    [0.00000000356, 0.2381908124, 5429.8794682394],
    [0.00000000346, 5.60809622572, 2379.1644735716],
    [0.0000000038, 2.72105213132, 11933.3679606696],
    [0.00000000432, 0.24215988572, 17996.0311682222],
    [0.00000000378, 5.22516848076, 7477.522860216],
    [0.00000000337, 5.10885555836, 5849.3641121146],
    [0.00000000315, 0.57827745123, 10557.5941608238],
    [0.00000000318, 4.4994900732, 3634.6210245184],
    [0.00000000323, 1.55850824803, 10440.2742926036],
    [0.00000000314, 5.77154773334, 20.7753954924],
    [0.00000000303, 2.34615580398, 4686.8894077068],
    [0.00000000414, 5.9323760231, 51092.7260508548],
    [0.00000000362, 2.17561997119, 28237.2334593894],
    [0.00000000288, 0.18377405421, 13095.8426650774],
    [0.00000000277, 5.1295220503, 13119.72110282519],
    [0.00000000325, 6.18608287927, 6268.8487559898],
    [0.00000000273, 0.30522428863, 23141.5583829246],
    [0.00000000267, 5.76152585786, 5966.6839803348],
    [0.00000000345, 2.94246040875, 36949.2308084242],
    [0.00000000253, 5.20994580359, 24072.9214697764],
    [0.00000000342, 5.76212804329, 16460.33352952499],
    [0.00000000307, 6.01039067183, 22805.7355659936],
    [0.00000000261, 2.00304796059, 6148.010769956],
    [0.00000000238, 5.08241964961, 6915.8595893046],
    [0.00000000249, 2.94762789744, 135.0650800354],
    [0.00000000306, 3.89765478921, 10988.808157535],
    [0.00000000308, 0.05451027736, 4701.1165017084],
    [0.00000000319, 2.95712862064, 163096.18036118349],
    [0.00000000272, 2.07967681309, 4804.209275927],
    [0.00000000209, 4.43768461442, 6546.1597733642],
    [0.00000000217, 0.73691592312, 6303.8512454838],
    [0.00000000203, 0.32033085531, 25934.1243310894],
    [0.00000000205, 5.22936478995, 20995.3929664494],
    [0.00000000213, 0.20671418919, 28286.9904848612],
    [0.00000000197, 0.4828613129, 16737.5772365966],
    [0.0000000023, 6.06567392849, 6287.0080032545],
    [0.00000000219, 1.291942163, 5326.7866940208],
    [0.00000000201, 1.74700937253, 22743.4093795164],
    [0.00000000207, 4.45440927276, 6279.4854213396],
    [0.00000000269, 6.0564044503, 64471.99124174489],
    [0.0000000019, 0.99261116842, 29296.6153895786],
    [0.00000000194, 3.82656562755, 419.4846438752],
    [0.00000000262, 5.26961924126, 522.5774180938],
    [0.0000000021, 4.68618183158, 6254.6266625236],
    [0.00000000197, 2.80624554186, 4933.2084403326],
    [0.00000000252, 4.3622015462, 40879.4405046438],
    [0.00000000261, 1.07241516738, 55022.9357470744],
    [0.00000000233, 5.41751014958, 39609.6545831656],
    [0.00000000185, 4.14324541379, 5642.1982426092],
    [0.00000000247, 3.44855612987, 6702.5604938666],
    [0.00000000205, 4.04424043226, 536.8045120954],
    [0.00000000191, 3.15807087926, 16723.350142595],
    [0.00000000222, 5.16259496507, 23539.7073863328],
    [0.0000000018, 4.56214752149, 6489.2613984286],
    [0.00000000227, 0.60156339452, 5905.7022420756],
    [0.0000000017, 0.93185903228, 16062.1845261168],
    [0.00000000159, 0.92751013112, 23937.856389741],
    [0.00000000157, 4.69607868164, 6805.6532680852],
    [0.00000000218, 0.8553337343, 16627.3709153772],
    [0.00000000169, 0.94641052064, 3097.88382272579],
    [0.00000000207, 4.88410451334, 6286.6662786432],
    [0.0000000016, 4.95943826819, 10021.8372800994],
    [0.00000000175, 6.12762824563, 239424.39025435288],
    [0.00000000173, 3.13887234973, 6179.9830757728],
    [0.00000000157, 3.62822057807, 18451.07854656599],
    [0.00000000206, 5.74617821138, 3646.3503773544],
    [0.00000000157, 4.67695912207, 6709.6740408674],
    [0.00000000146, 3.09506069745, 4907.3020501456],
    [0.00000000165, 2.2713912876, 10660.6869350424],
    [0.00000000144, 3.96947747592, 6019.9919266186],
    [0.00000000171, 5.91302216729, 6058.7310542895],
    [0.00000000144, 2.1315565512, 26084.0218062162],
    [0.00000000151, 0.67417383565, 2388.8940204492],
    [0.00000000196, 1.67718461229, 2107.0345075424],
    [0.00000000146, 5.10373877968, 10770.8932562618],
    [0.00000000187, 1.23915444627, 19402.7969528166],
    [0.00000000137, 1.26247412216, 12566.2190102856],
    [0.00000000191, 5.03547476279, 263.0839233728],
    [0.00000000137, 3.52825454595, 639.897286314],
    [0.00000000135, 0.73840670927, 5017.508371365],
    [0.00000000164, 2.39195095081, 6357.8574485587],
    [0.00000000168, 0.05515907462, 9380.9596727172],
    [0.00000000161, 1.15721259392, 26735.9452622132],
    [0.00000000144, 1.76097645199, 5888.4499649322],
    [0.00000000131, 2.51859277344, 6599.467719648],
    [0.00000000142, 2.43802911123, 5881.4037282342],
    [0.00000000159, 5.90325893762, 6281.5913772831],
    [0.00000000151, 3.72338532519, 12669.2444742014],
    [0.00000000132, 2.38417741883, 6525.8044539654],
    [0.00000000127, 0.00254936441, 10027.9031957292],
    [0.00000000148, 2.85102145528, 6418.1409300268],
    [0.00000000143, 5.7446027956, 26087.9031415742],
    [0.00000000172, 0.4128996224, 174242.4659640497],
    [0.00000000136, 4.15497742275, 6311.5250374592],
    [0.0000000017, 5.98194913129, 327574.51427678125],
    [0.00000000136, 2.48430537541, 13341.6743113068],
    [0.00000000149, 0.33002271275, 245.8316462294],
    [0.00000000165, 2.496679246, 58953.145443294],
    [0.00000000123, 1.67328384813, 32217.2001810808],
    [0.00000000123, 3.45660563754, 6277.552925684],
    [0.00000000117, 0.86065134175, 6245.0481773556],
    [0.00000000149, 5.61358281003, 5729.506447149],
    [0.00000000128, 0.71204006448, 103.0927742186],
    [0.00000000159, 2.43166592149, 221995.02880149524],
    [0.00000000137, 1.706577092, 12566.08438968],
    [0.00000000129, 2.80667872683, 6016.4688082696],
    [0.00000000113, 3.58302904101, 25685.872802808],
    [0.00000000109, 3.26403795962, 6819.8803620868],
    [0.00000000122, 0.34120688202, 1162.4747044078],
    [0.00000000106, 1.59721172719, 17782.7320727842],
    [0.00000000144, 2.28891651774, 12489.8856287072],
    [0.00000000137, 5.82029768354, 44809.6502008634],
    [0.00000000134, 1.26539983018, 5331.3574437408],
    [0.00000000103, 5.96518130595, 6321.1035226272],
    [0.00000000109, 0.33808549034, 11300.5842213564],
    [0.00000000129, 5.8918727719, 12029.3471878874],
    [0.00000000122, 5.77325634636, 11919.140866668],
    [0.00000000107, 6.2499898935, 77690.75950573849],
    [0.00000000107, 1.00535580713, 77736.78343050249],
    [0.00000000115, 5.86963518266, 12721.572099417],
    [0.00000000102, 5.66283467269, 5540.0857894588],
    [0.00000000143, 0.24122178432, 4214.0690150848],
    [0.00000000143, 0.88529649733, 7576.560073574],
    [0.00000000107, 2.92124030351, 31415.379249957],
    [0.000000001, 5.99485644501, 4061.2192153944],
    [0.00000000103, 2.41941934525, 5547.1993364596],
    [0.00000000104, 4.44106051277, 2118.7638603784],
    [0.0000000011, 0.37559635174, 5863.5912061162],
    [0.00000000124, 2.55619029611, 12539.853380183],
    [0.0000000011, 3.66952094465, 238004.52415723629],
    [0.00000000112, 4.32512422724, 97238.62754448749],
    [0.0000000012, 1.26895630075, 12043.574281889],
    [0.00000000097, 5.42612959752, 7834.1210726394],
    [0.00000000094, 2.56461130309, 19004.6479494084],
    [0.00000000105, 5.68272475301, 16522.6597160022],
    [0.00000000117, 3.65425622684, 34520.3093093808],
    [0.00000000108, 1.24206843948, 84672.47584450469],
    [0.00000000098, 0.13589994287, 11080.1715789176],
    [0.00000000097, 2.46722096722, 71980.63357473118],
    [0.00000000095, 5.36958330451, 6288.5987742988],
    [0.00000000096, 0.20796618776, 18139.2945014159],
    [0.00000000111, 5.01961920313, 11823.1616394502],
    [0.0000000009, 2.72355843779, 26880.3198130326],
    [0.00000000099, 0.90164266199, 18635.9284545362],
    [0.00000000126, 4.78722177847, 305281.94307104882],
    [0.00000000124, 5.00979495566, 172146.97134054029],
    [0.0000000009, 4.50544881196, 40077.61957352],
    [0.00000000104, 5.6367968071, 2787.0430238574],
    [0.00000000091, 5.43564326147, 6272.0301497275],
    [0.000000001, 2.00639461597, 12323.4230960088],
    [0.00000000117, 2.35555589778, 83286.91426955358],
    [0.00000000105, 2.59824000109, 30666.1549584328],
    [0.0000000009, 2.35779490026, 12491.3701014155],
    [0.00000000089, 3.57152453732, 11720.0688652316],
    [0.00000000095, 5.67015349858, 14919.0178537546],
    [0.00000000087, 1.86043406047, 27707.5424942948],
    [0.00000000106, 3.04150600352, 22345.2603761082],
    [0.00000000082, 5.58298993353, 10241.2022911672],
    [0.00000000083, 3.10607039533, 36147.4098773004],
    [0.00000000094, 5.47749711149, 9924.8104215106],
    [0.00000000082, 4.71988314145, 15141.390794312],
    [0.00000000096, 3.89073946348, 6379.0550772092],
    [0.0000000011, 4.92131611151, 5621.8429232104],
    [0.0000000011, 4.89978492291, 72140.62866668739],
    [0.00000000097, 5.20764563059, 6303.4311693902],
    [0.00000000085, 1.61269222311, 33326.5787331742],
    [0.00000000093, 1.32651591333, 23020.65308658799],
    [0.0000000009, 0.5773301638, 26482.1708096244],
    [0.00000000078, 3.99588630754, 11293.4706743556],
    [0.00000000106, 3.92012705073, 62883.3551395136],
    [0.00000000098, 2.94397773524, 316.3918696566],
    [0.00000000076, 3.96310417608, 29026.48522950779],
    [0.00000000098, 0.95914722366, 48739.859897083],
    [0.00000000078, 1.97068528043, 90279.92316810328],
    [0.00000000076, 0.23027966596, 21424.4666443034],
    [0.00000000079, 1.46227790922, 8982.810669309],
    [0.00000000078, 2.28840998832, 266.6070417218],
    [0.00000000071, 1.5194076559, 33794.5437235286],
    [0.00000000076, 0.22880641443, 57375.8019008462],
    [0.00000000097, 0.39449562097, 24279.10701821359],
    [0.00000000075, 2.77638584795, 12964.300703391],
    [0.00000000077, 5.18846946344, 11520.9968637952],
    [0.00000000068, 0.50006599129, 4274.5183108324],
    [0.00000000075, 2.07323762803, 15664.03552270859],
    [0.00000000077, 0.4666517878, 16207.886271502],
    [0.00000000081, 4.10452219483, 161710.61878623239],
    [0.00000000071, 3.91415328513, 7875.6718636242],
    [0.00000000081, 0.91938383406, 74.7815985673],
    [0.00000000083, 4.69916218791, 23006.42599258639],
    [0.00000000069, 0.98999300277, 6393.2821712108],
    [0.00000000065, 5.41938745446, 28628.3362260996],
    [0.00000000073, 2.45564765251, 15508.6151232744],
    [0.00000000065, 3.02336771694, 5959.570433334],
    [0.00000000064, 0.18375587635, 1066.49547719],
    [0.0000000008, 5.81239171612, 12341.8069042809],
    [0.00000000066, 2.15105504851, 38.0276726358],
    [0.00000000067, 5.14047250153, 9814.6041002912],
    [0.00000000062, 2.43313614978, 10138.1095169486],
    [0.00000000068, 2.24442548639, 24383.0791084414],
    [0.00000000078, 1.39649333997, 9411.4646150872],
    [0.00000000059, 4.95362151577, 35707.7100829074],
    [0.00000000073, 1.35229143121, 5327.4761083828],
    [0.00000000057, 3.16018882154, 5490.300961524],
    [0.00000000072, 5.91833527334, 10881.0995774812],
    [0.00000000067, 0.66414713064, 29864.334027309],
    [0.00000000065, 0.30352816135, 7018.9523635232],
    [0.00000000059, 5.36231868425, 10239.5838660108],
    [0.00000000056, 3.22196331515, 2636.725472637],
    [0.00000000068, 5.32086226658, 3116.6594122598],
    [0.00000000059, 1.63156134967, 61306.0115970658],
    [0.00000000054, 4.29491690425, 21947.1113727],
    [0.0000000007, 0.29271565928, 6528.9074962208],
    [0.00000000057, 5.89190132575, 34513.2630726828],
    [0.00000000054, 2.51856815404, 6279.1945146334],
    [0.00000000074, 1.38235845304, 9967.4538999816],
    [0.00000000054, 0.92276712152, 6286.9571853494],
    [0.0000000007, 5.00933012248, 6453.7487206106],
    [0.00000000053, 3.86543309344, 32370.9789915656],
    [0.00000000055, 4.51794544854, 34911.412076091],
    [0.00000000063, 5.41479412056, 11502.8376165305],
    [0.00000000063, 2.34416220742, 11510.7019230567],
    [0.00000000056, 0.91310629913, 9910.583327509],
    [0.00000000067, 4.03308763854, 34596.3646546524],
    [0.0000000006, 5.57024703495, 5756.9080032458],
    [0.00000000072, 2.80863088166, 10866.8724834796],
    [0.00000000066, 6.12047940728, 12074.488407524],
    [0.00000000051, 2.59519527563, 11396.5634485742],
    [0.00000000062, 5.14746754396, 25287.7237993998],
    [0.00000000054, 2.50994032776, 5999.2165311262],
    [0.00000000051, 4.51195861837, 29822.7832363242],
    [0.00000000059, 0.44167237876, 250570.67585721909],
    [0.00000000051, 3.6884906676, 6262.7205305926],
    [0.00000000049, 0.54704693048, 22594.05489571199],
    [0.00000000065, 2.38423614501, 52670.0695933026],
    [0.00000000069, 5.34363738671, 66813.5648357332],
    [0.00000000056, 2.67216180349, 17892.93839400359],
    [0.00000000049, 4.18361320516, 18606.4989460002],
    [0.00000000055, 0.83886167974, 20452.8694122218],
    [0.0000000005, 1.46327331958, 37455.7264959744],
    [0.00000000058, 3.34847975377, 33990.6183442862],
    [0.00000000065, 1.45522693982, 76251.32777062019],
    [0.00000000056, 2.356506642, 37724.7534197482],
    [0.00000000048, 1.80689447612, 206.1855484372],
    [0.00000000056, 3.84224878744, 5483.254724826],
    [0.00000000053, 0.17334326094, 77717.29458646949],
    [0.00000000053, 0.79879700631, 77710.24834977149],
    [0.00000000047, 0.43240779709, 735.8765135318],
    [0.00000000053, 4.58786566028, 11616.976091013],
    [0.00000000048, 6.20230111054, 4171.4255366138],
    [0.00000000052, 2.9171905303, 6993.0088985497],
    [0.00000000057, 3.42008310383, 50317.2034395308],
    [0.00000000048, 0.12356889012, 13362.4497067992],
    [0.0000000006, 5.52056066934, 949.1756089698],
    [0.00000000045, 3.37963782356, 10763.779709261],
    [0.00000000047, 5.50958184902, 12779.4507954208],
    [0.00000000052, 5.42770349015, 310145.15282392364],
    [0.00000000061, 2.93237974631, 5791.4125575326],
    [0.00000000044, 2.87440620802, 8584.6616659008],
    [0.00000000046, 4.0314179656, 10667.8004820432],
    [0.00000000044, 1.21579107625, 6272.4391846416],
    [0.00000000047, 2.57670800912, 11492.542675792],
    [0.00000000044, 3.62570223167, 63658.8777508376],
    [0.00000000051, 0.84531181151, 12345.739057544],
    [0.00000000046, 1.17584556517, 149.5631971346],
    [0.00000000043, 0.01524970172, 37853.8754993826],
    [0.00000000043, 0.79038834934, 640.8776073822],
    [0.00000000044, 2.22554419931, 6293.7125153412],
    [0.00000000049, 1.01528394907, 149144.46708624958],
    [0.00000000041, 3.27146326065, 8858.3149443206],
    [0.00000000045, 3.03765521215, 65236.2212932854],
    [0.00000000058, 5.45843180927, 1975.492545856],
    [0.00000000041, 1.32190847146, 2547.8375382324],
    [0.00000000047, 3.67626039848, 28313.288804661],
    [0.00000000047, 6.21438985953, 10991.3058987006],
    [0.0000000004, 2.37237751212, 8273.8208670324],
    [0.00000000056, 1.09773690181, 77376.20102240759],
    [0.0000000004, 2.35698541041, 2699.7348193176],
    [0.00000000043, 5.28030897946, 17796.9591667858],
    [0.00000000054, 2.59175932091, 22910.44676536859],
    [0.00000000055, 0.07988985505, 83467.15635301729],
    [0.00000000041, 4.47510694062, 5618.3198048614],
    [0.0000000004, 1.35670430524, 27177.8515292002],
    [0.00000000041, 2.48011323946, 6549.6828917132],
    [0.0000000005, 2.56387920528, 82576.98122099529],
    [0.00000000042, 4.78798367468, 7856.89627409019],
    [0.00000000047, 2.75482175292, 18202.21671665939],
    [0.00000000039, 1.97008298629, 24491.4257925834],
    [0.00000000042, 4.04346599946, 7863.9425107882],
    [0.00000000039, 3.0103393642, 853.196381752],
    [0.00000000038, 0.49178679251, 38650.173506199],
    [0.00000000044, 1.35931241699, 21393.5419698576],
    [0.00000000036, 4.86047906533, 4157.1984426122],
    [0.00000000043, 5.64354880978, 1062.9050485382],
    [0.00000000039, 3.92736779879, 3903.9113764198],
    [0.0000000004, 5.3969491832, 9498.2122306346],
    [0.00000000043, 2.40863861919, 29424.634232916],
    [0.00000000046, 2.08022244271, 12573.2652469836],
    [0.0000000005, 6.15760345261, 78051.34191383338],
];

const VSOP87_R1: Vsop87Element = [
    [0.00103018607, 1.10748968172, 6283.0758499914],
    [0.00001721238, 1.06442300386, 12566.1516999828],
    [0.00000702217, Math.PI],
    [0.00000032345, 1.02168583254, 18849.2275499742],
    [0.00000030801, 2.84358443952, 5507.5532386674],
    [0.00000024978, 1.31906570344, 5223.6939198022],
    [0.00000018487, 1.42428709076, 1577.3435424478],
    [0.00000010077, 5.91385248388, 10977.078804699],
    [0.00000008635, 0.27158192945, 5486.777843175],
    [0.00000008654, 1.42046854427, 6275.9623029906],
    [0.00000005069, 1.68613408916, 5088.6288397668],
    [0.00000004985, 6.01402338185, 6286.5989683404],
    [0.00000004667, 5.98749245692, 529.6909650946],
    [0.00000004395, 0.51800423445, 4694.0029547076],
    [0.0000000387, 4.74932206877, 2544.3144198834],
    [0.00000003755, 5.07053801166, 796.2980068164],
    [0.000000041, 1.08424801084, 9437.762934887],
    [0.00000003518, 0.02290216978, 83996.84731811189],
    [0.00000003436, 0.94937503872, 71430.69561812909],
    [0.00000003221, 6.15628775321, 2146.1654164752],
    [0.00000003418, 5.4115158188, 775.522611324],
    [0.00000002863, 5.48433323746, 10447.3878396044],
    [0.00000002525, 0.24296913555, 398.1490034082],
    [0.00000002205, 4.94892172085, 6812.766815086],
    [0.00000002186, 0.41991932164, 8031.0922630584],
    [0.00000002828, 3.41986300734, 2352.8661537718],
    [0.00000002554, 6.13241770582, 6438.4962494256],
    [0.00000001932, 5.31374587091, 8429.2412664666],
    [0.00000002427, 3.09118902115, 4690.4798363586],
    [0.0000000173, 1.53685999718, 4705.7323075436],
    [0.0000000225, 3.6883639562, 7084.8967811152],
    [0.00000002094, 1.281690604, 1748.016413067],
    [0.00000001483, 3.22226346483, 7234.794256242],
    [0.00000001434, 0.81293662216, 14143.4952424306],
    [0.00000001754, 3.22883705112, 6279.5527316424],
    [0.00000001583, 4.09815978783, 11499.6562227928],
    [0.00000001575, 5.53890314149, 3154.6870848956],
    [0.00000001847, 1.82041234937, 7632.9432596502],
    [0.00000001499, 3.63177937611, 11513.8833167944],
    [0.00000001337, 4.64442556061, 6836.6452528338],
    [0.00000001275, 2.69329661394, 1349.8674096588],
    [0.00000001348, 6.15284035323, 5746.271337896],
    [0.00000001126, 3.35676107739, 17789.845619785],
    [0.0000000147, 3.65282991735, 1194.4470102246],
    [0.00000001101, 4.4974742767, 4292.3308329504],
    [0.00000001168, 2.58033028504, 13367.9726311066],
    [0.00000001236, 5.64980098028, 5760.4984318976],
    [0.00000000985, 0.65326301914, 5856.4776591154],
    [0.00000000928, 2.3255501829, 10213.285546211],
    [0.00000001073, 5.82672338169, 12036.4607348882],
    [0.00000000918, 0.76907130762, 16730.4636895958],
    [0.00000000876, 1.50335727807, 11926.2544136688],
    [0.00000001023, 5.62071200879, 6256.7775301916],
    [0.00000000853, 0.6567813463, 155.4203994342],
    [0.00000000802, 4.10519132094, 951.7184062506],
    [0.00000000859, 1.42880883564, 5753.3848848968],
    [0.00000000992, 1.1423800161, 1059.3819301892],
    [0.00000000814, 1.63584008733, 6681.2248533996],
    [0.00000000664, 4.55039663226, 5216.5803728014],
    [0.00000000627, 1.50782904323, 5643.1785636774],
    [0.00000000644, 4.19480024859, 6040.3472460174],
    [0.0000000059, 6.18371704849, 4164.311989613],
    [0.00000000635, 0.5242358477, 6290.1893969922],
    [0.0000000065, 0.97935492869, 25132.3033999656],
    [0.00000000568, 2.30121525349, 10973.55568635],
    [0.00000000549, 5.26737827342, 3340.6124266998],
    [0.00000000547, 2.20143332641, 1592.5960136328],
    [0.00000000526, 0.92464258271, 11371.7046897582],
    [0.00000000493, 5.91036281399, 3894.1818295422],
    [0.00000000483, 1.6600571154, 12168.0026965746],
    [0.00000000514, 3.59683072524, 10969.9652576982],
    [0.00000000516, 3.97164781773, 17298.1823273262],
    [0.00000000529, 5.0353867768, 9917.6968745098],
    [0.00000000487, 2.50544745305, 6127.6554505572],
    [0.00000000419, 4.05235655996, 10984.1923516998],
    [0.00000000538, 5.54081539813, 553.5694028424],
    [0.00000000402, 2.16859478359, 7860.4193924392],
    [0.00000000552, 2.32219865498, 11506.7697697936],
    [0.00000000367, 3.39145698451, 6496.3749454294],
    [0.0000000036, 5.34467204596, 7079.3738568078],
    [0.00000000334, 3.61346365667, 11790.6290886588],
    [0.00000000454, 0.28755421898, 801.8209311238],
    [0.00000000419, 3.69613970002, 10575.4066829418],
    [0.00000000319, 0.30793759304, 16200.7727245012],
    [0.00000000376, 5.81560210508, 7058.5984613154],
    [0.00000000364, 1.08425056923, 6309.3741697912],
    [0.00000000294, 4.54798604178, 11856.2186514245],
    [0.0000000029, 1.26451946335, 8635.9420037632],
    [0.00000000394, 4.15683669084, 26.2983197998],
    [0.0000000026, 5.09424572996, 10177.2576795336],
    [0.00000000241, 2.25766000302, 11712.9553182308],
    [0.00000000239, 1.06936978753, 242.728603974],
    [0.00000000276, 3.44260568764, 5884.9268465832],
    [0.00000000255, 5.38496803122, 21228.3920235458],
    [0.00000000307, 4.24313885601, 3738.761430108],
    [0.00000000213, 3.44661200485, 213.299095438],
    [0.00000000198, 0.69427265195, 1990.745017041],
    [0.00000000195, 5.16563409007, 12352.8526045448],
    [0.00000000213, 3.89937836808, 13916.0191096416],
    [0.00000000214, 4.00445200772, 5230.807466803],
    [0.00000000184, 5.59805976614, 6283.14316029419],
    [0.00000000184, 2.85275392124, 7238.6755916],
    [0.00000000179, 2.54259058252, 14314.1681130498],
    [0.00000000236, 5.58826125715, 6069.7767545534],
    [0.00000000189, 2.72689937708, 6062.6632075526],
    [0.00000000184, 6.04216273598, 6283.0085396886],
    [0.00000000225, 1.66128561344, 4732.0306273434],
    [0.0000000023, 3.62591335086, 6284.0561710596],
    [0.00000000172, 0.97566476085, 3930.2096962196],
    [0.00000000162, 2.19467339429, 18073.7049386502],
    [0.00000000215, 1.04672844028, 3496.032826134],
    [0.00000000182, 5.17782354566, 17253.04110768959],
    [0.00000000167, 2.17754938066, 6076.8903015542],
    [0.00000000167, 4.75672473773, 17267.26820169119],
    [0.00000000149, 0.80944185798, 709.9330485583],
    [0.00000000149, 0.17584214812, 9779.1086761254],
    [0.00000000192, 5.00680790235, 11015.1064773348],
    [0.00000000141, 4.38420380014, 4136.9104335162],
    [0.00000000158, 4.60969054283, 9623.6882766912],
    [0.00000000133, 3.30507062245, 154717.60988768269],
    [0.00000000166, 6.13191098325, 3.523118349],
    [0.00000000181, 1.60715321141, 7.1135470008],
    [0.0000000015, 5.28136702046, 13517.8701062334],
    [0.00000000142, 0.49788089569, 25158.6017197654],
    [0.00000000124, 6.03440459813, 9225.539273283],
    [0.00000000124, 0.99251562639, 65147.6197681377],
    [0.00000000128, 1.92032744711, 22483.84857449259],
    [0.00000000124, 3.99739675184, 4686.8894077068],
    [0.00000000121, 2.37814805239, 167283.76158766549],
    [0.00000000123, 5.6231511294, 5642.1982426092],
    [0.00000000117, 5.81755956156, 12569.6748183318],
    [0.00000000157, 3.40236948518, 16496.3613962024],
    [0.0000000013, 2.10499918142, 1589.0728952838],
    [0.00000000116, 0.55839966736, 5849.3641121146],
    [0.00000000123, 5.81645568991, 6282.0955289232],
    [0.0000000011, 0.42176497674, 6172.869528772],
    [0.0000000015, 4.26279600865, 3128.3887650958],
    [0.00000000106, 2.27436561182, 5429.8794682394],
    [0.00000000114, 1.52894564202, 12559.038152982],
    [0.00000000121, 0.39459045915, 12132.439962106],
    [0.00000000104, 2.41845930933, 426.598190876],
    [0.00000000109, 5.82786999856, 16858.4825329332],
    [0.00000000102, 4.4662648491, 23543.23050468179],
    [0.000000001, 2.93812275274, 4535.0594369244],
    [0.00000000097, 3.97935904984, 6133.5126528568],
    [0.00000000098, 0.87616810121, 6525.8044539654],
    [0.0000000011, 6.22339014386, 12146.6670561076],
    [0.00000000098, 3.17344332543, 10440.2742926036],
    [0.00000000096, 2.44128701699, 3097.88382272579],
    [0.00000000099, 5.75642493267, 7342.4577801806],
    [0.0000000009, 0.18984343165, 13119.72110282519],
    [0.00000000099, 5.58884724219, 2388.8940204492],
    [0.00000000091, 6.04278320182, 20426.571092422],
    [0.0000000008, 1.29028142103, 5650.2921106782],
    [0.00000000086, 3.94529200528, 10454.5013866052],
    [0.00000000085, 1.92836879835, 29088.811415985],
    [0.00000000076, 2.70726317966, 143571.32428481648],
    [0.00000000091, 5.63859073351, 8827.3902698748],
    [0.00000000076, 1.80783856698, 28286.9904848612],
    [0.00000000075, 3.40858032804, 5481.2549188676],
    [0.0000000007, 4.53719487231, 17256.6315363414],
    [0.00000000089, 1.10064490942, 11769.8536931664],
    [0.00000000066, 2.78384937771, 536.8045120954],
    [0.00000000068, 3.88199295043, 17260.1546546904],
    [0.00000000088, 3.88075269535, 7477.522860216],
    [0.00000000061, 6.17558202197, 11087.2851259184],
    [0.0000000006, 4.34824715818, 6206.8097787158],
    [0.00000000082, 4.59843208943, 9388.0059094152],
    [0.00000000079, 1.63139280394, 4933.2084403326],
    [0.00000000081, 1.55550779371, 9380.9596727172],
    [0.00000000078, 4.20905757519, 5729.506447149],
    [0.00000000058, 5.76889633224, 3634.6210245184],
    [0.0000000006, 0.93813100594, 12721.572099417],
    [0.00000000071, 6.11408885148, 8662.240323563],
    [0.00000000057, 5.48112524468, 18319.5365848796],
    [0.0000000007, 0.01749174864, 14945.3161735544],
    [0.00000000074, 1.0997604582, 16460.33352952499],
    [0.00000000056, 1.63036186739, 15720.8387848784],
    [0.00000000055, 4.86788348404, 13095.8426650774],
    [0.0000000006, 5.93729841267, 12539.853380183],
    [0.00000000054, 0.22608242982, 15110.4661198662],
    [0.00000000054, 2.30250047594, 16062.1845261168],
    [0.00000000064, 2.13513754101, 7875.6718636242],
    [0.00000000059, 5.87963500139, 5331.3574437408],
    [0.00000000058, 2.30546168615, 955.5997416086],
    [0.00000000049, 1.93839278478, 5333.9002410216],
    [0.00000000054, 5.80331607119, 12043.574281889],
    [0.00000000054, 4.44671053809, 4701.1165017084],
    [0.00000000049, 0.30241161485, 6805.6532680852],
    [0.00000000046, 2.76898193028, 6709.6740408674],
    [0.00000000046, 3.98449608961, 98068.53671630539],
    [0.00000000049, 3.72022009896, 12323.4230960088],
    [0.00000000045, 3.30065998328, 22003.9146348698],
    [0.00000000048, 0.71071357303, 6303.4311693902],
    [0.00000000061, 1.66030429494, 6262.300454499],
    [0.00000000047, 1.26317154881, 11919.140866668],
    [0.00000000051, 1.08020906825, 10988.808157535],
    [0.00000000045, 0.89150445122, 51868.2486621788],
    [0.00000000043, 0.57756724285, 24356.7807886416],
    [0.00000000043, 1.61526242998, 6277.552925684],
    [0.00000000045, 2.96132920534, 8982.810669309],
    [0.00000000043, 5.74295325645, 11403.676995575],
    [0.00000000055, 3.14274403422, 33019.0211122046],
    [0.00000000057, 0.06379726305, 15671.0817594066],
    [0.00000000041, 2.53761820726, 6262.7205305926],
    [0.0000000004, 1.53130436944, 18451.07854656599],
    [0.00000000052, 1.71451922581, 1551.045222648],
    [0.00000000055, 0.89439119424, 11933.3679606696],
    [0.00000000045, 3.88495384656, 60530.4889857418],
    [0.0000000004, 4.75740908001, 38526.574350872],
    [0.0000000004, 3.77498297348, 26087.9031415742],
    [0.00000000039, 2.97113832621, 2118.7638603784],
    [0.0000000004, 3.36050962605, 10021.8372800994],
    [0.00000000047, 1.67051113434, 6303.8512454838],
    [0.00000000052, 5.21827368711, 77713.7714681205],
    [0.00000000047, 4.26356628717, 21424.4666443034],
    [0.00000000037, 1.66712389942, 6819.8803620868],
    [0.00000000037, 0.65746800933, 12029.3471878874],
    [0.00000000035, 3.36255650927, 24072.9214697764],
    [0.00000000036, 0.11087914947, 10344.2950653858],
    [0.0000000004, 4.14725582115, 2787.0430238574],
    [0.00000000035, 5.93650887012, 31570.7996493912],
    [0.00000000036, 2.15108874765, 30774.5016425748],
    [0.00000000036, 1.75078825382, 16207.886271502],
    [0.00000000034, 2.75708224536, 12139.5535091068],
    [0.00000000034, 6.168913788, 24491.4257925834],
    [0.00000000034, 2.31528650443, 55798.4583583984],
    [0.00000000032, 4.21446357042, 15664.03552270859],
    [0.00000000034, 3.19783054699, 32217.2001810808],
    [0.00000000039, 1.24979117796, 6418.1409300268],
    [0.00000000038, 5.89832942685, 640.8776073822],
    [0.00000000033, 4.80200120107, 16723.350142595],
    [0.00000000032, 1.72442327688, 27433.88921587499],
    [0.00000000035, 4.44608896525, 18202.21671665939],
    [0.00000000031, 4.5279073128, 6702.5604938666],
    [0.00000000034, 3.96287980676, 18216.443810661],
    [0.0000000003, 5.06259854444, 226858.23855437008],
    [0.00000000034, 1.43910280005, 49515.382508407],
    [0.0000000003, 0.29303163371, 13521.7514415914],
    [0.00000000029, 2.0263384022, 11609.8625440122],
    [0.0000000003, 2.5492323024, 9924.8104215106],
    [0.00000000032, 4.91793198558, 11300.5842213564],
    [0.0000000003, 0.23284423547, 23581.2581773176],
    [0.00000000029, 1.62807736495, 639.897286314],
    [0.00000000028, 3.84568936822, 2699.7348193176],
    [0.00000000029, 1.83149729794, 29822.7832363242],
    [0.00000000033, 4.60320094415, 19004.6479494084],
    [0.00000000027, 1.86151121799, 6288.5987742988],
    [0.0000000003, 4.4649407224, 36147.4098773004],
    [0.00000000028, 5.19684492912, 5863.5912061162],
    [0.00000000035, 4.52695674113, 36949.2308084242],
    [0.00000000027, 3.52528177609, 10770.8932562618],
    [0.00000000026, 1.48499438453, 11080.1715789176],
    [0.00000000035, 2.82154380962, 19402.7969528166],
    [0.00000000025, 2.46339998836, 6279.4854213396],
    [0.00000000026, 4.97688894643, 16737.5772365966],
    [0.00000000027, 0.408271125, 12964.300703391],
    [0.00000000029, 4.15148654061, 45892.73043315699],
    [0.00000000026, 4.56404104286, 17796.9591667858],
    [0.00000000025, 2.89309528854, 6286.6662786432],
    [0.00000000026, 4.82914580957, 1066.49547719],
    [0.00000000031, 3.93096113738, 29864.334027309],
    [0.00000000024, 6.14987193584, 18606.4989460002],
    [0.00000000024, 3.74225964547, 29026.48522950779],
    [0.00000000025, 5.70460621565, 27707.5424942948],
    [0.00000000025, 5.33928840652, 15141.390794312],
    [0.00000000023, 2.37624087345, 17996.0311682222],
    [0.00000000026, 1.34231351782, 18875.525869774],
    [0.00000000022, 5.5079162612, 6245.0481773556],
    [0.00000000024, 1.33998410121, 19800.9459562248],
    [0.00000000023, 0.2251228089, 6279.7894925736],
    [0.00000000022, 1.17576471775, 11925.2740926006],
    [0.00000000022, 3.5860360664, 6915.8595893046],
    [0.00000000023, 3.21621246666, 6286.3622074092],
    [0.00000000029, 2.09564449439, 15265.8865193004],
    [0.00000000022, 4.74660932338, 28230.18722269139],
    [0.00000000021, 2.30688751432, 5999.2165311262],
    [0.00000000028, 3.92087592807, 18208.349942592],
    [0.00000000021, 3.22643339385, 25934.1243310894],
    [0.00000000021, 3.04956726238, 6566.9351688566],
    [0.00000000027, 5.35645770522, 33794.5437235286],
    [0.00000000025, 5.91542362188, 6489.2613984286],
    [0.0000000002, 1.52296293311, 135.0650800354],
    [0.00000000019, 1.78134428631, 156137.47598479928],
    [0.00000000019, 0.34388684087, 5327.4761083828],
    [0.00000000026, 3.41701003233, 25287.7237993998],
    [0.00000000019, 2.86664271911, 18422.62935909819],
    [0.00000000019, 4.71432851499, 77690.75950573849],
    [0.00000000019, 2.54227398241, 77736.78343050249],
    [0.0000000002, 5.91915117116, 48739.859897083],
];

const VSOP87_R2: Vsop87Element = [
    [0.00004359385, 5.78455133808, 6283.0758499914],
    [0.00000123633, 5.57935427994, 12566.1516999828],
    [0.00000012342, Math.PI],
    [0.00000008792, 3.62777893099, 77713.7714681205],
    [0.00000005689, 1.86958905084, 5573.1428014331],
    [0.00000003302, 5.47034879713, 18849.2275499742],
    [0.00000001471, 4.47964125007, 5507.5532386674],
    [0.00000001013, 2.81323115556, 5223.6939198022],
    [0.00000000854, 3.107765669, 1577.3435424478],
    [0.00000001102, 2.84173992403, 161000.6857376741],
    [0.00000000648, 5.47348203398, 775.522611324],
    [0.00000000608, 1.37894173533, 6438.4962494256],
    [0.00000000499, 4.4164924225, 6286.5989683404],
    [0.00000000416, 0.90332697974, 10977.078804699],
    [0.00000000404, 3.2056726953, 5088.6288397668],
    [0.00000000351, 1.81081728907, 5486.777843175],
    [0.00000000466, 3.65086758149, 7084.8967811152],
    [0.00000000458, 5.38585314743, 149854.40013480789],
    [0.00000000304, 3.51015066341, 796.2980068164],
    [0.00000000266, 6.17413982699, 6836.6452528338],
    [0.00000000281, 1.8387467254, 4694.0029547076],
    [0.00000000262, 1.41420110644, 2146.1654164752],
    [0.00000000264, 3.14103683911, 71430.69561812909],
    [0.00000000319, 5.35037932146, 3154.6870848956],
    [0.00000000238, 2.17695432424, 155.4203994342],
    [0.00000000229, 4.7596958807, 7234.794256242],
    [0.00000000291, 4.61776401638, 4690.4798363586],
    [0.00000000211, 0.21864885298, 4705.7323075436],
    [0.00000000204, 4.22895113488, 1349.8674096588],
    [0.00000000195, 4.58550676556, 529.6909650946],
    [0.00000000255, 2.81442711144, 1748.016413067],
    [0.00000000182, 5.70454011389, 6040.3472460174],
    [0.0000000018, 6.02147727878, 4292.3308329504],
    [0.00000000186, 1.58690991244, 6309.3741697912],
    [0.00000000167, 2.88802733052, 9437.762934887],
    [0.00000000166, 1.99990574734, 8031.0922630584],
    [0.0000000016, 0.04412738495, 2544.3144198834],
    [0.00000000197, 2.01089431842, 1194.4470102246],
    [0.00000000165, 5.78372596774, 83996.84731811189],
    [0.00000000214, 3.38300910371, 7632.9432596502],
    [0.0000000014, 0.36669664351, 10447.3878396044],
    [0.00000000151, 0.95519595275, 6127.6554505572],
    [0.00000000136, 1.48417295645, 2352.8661537718],
    [0.00000000128, 5.48057748834, 951.7184062506],
    [0.00000000126, 5.26866506592, 6279.5527316424],
    [0.00000000127, 3.77552907014, 6812.766815086],
    [0.00000000103, 4.95897533789, 398.1490034082],
    [0.00000000104, 0.70183576826, 1592.5960136328],
    [0.00000000101, 1.14481598642, 3894.1818295422],
    [0.00000000131, 0.76624310306, 553.5694028424],
    [0.00000000109, 5.41063597567, 6256.7775301916],
    [0.00000000078, 5.84775340741, 242.728603974],
    [0.00000000097, 1.94685257714, 11856.2186514245],
    [0.000000001, 5.19725292131, 244287.60000722769],
    [0.00000000076, 0.70480774041, 8429.2412664666],
    [0.0000000008, 6.18430772683, 1059.3819301892],
    [0.00000000068, 5.29561709093, 14143.4952424306],
    [0.00000000085, 5.39487308005, 25132.3033999656],
    [0.00000000055, 5.16874637579, 7058.5984613154],
    [0.00000000063, 0.48494730699, 801.8209311238],
    [0.00000000058, 4.07254840265, 13367.9726311066],
    [0.00000000051, 3.89696552232, 12036.4607348882],
    [0.00000000051, 5.56335232286, 1990.745017041],
    [0.0000000006, 2.2504659671, 8635.9420037632],
    [0.00000000049, 5.58163417371, 6290.1893969922],
    [0.00000000051, 3.87240194908, 26.2983197998],
    [0.00000000051, 4.19300909995, 7860.4193924392],
    [0.00000000041, 3.97169191582, 10973.55568635],
    [0.00000000041, 3.5708091923, 7079.3738568078],
    [0.00000000056, 2.76959005761, 90955.5516944961],
    [0.00000000042, 1.91461189163, 7477.522860216],
    [0.00000000042, 0.42775891995, 10213.285546211],
    [0.00000000042, 1.06925480488, 709.9330485583],
    [0.00000000038, 6.17935925345, 9917.6968745098],
    [0.0000000005, 0.81691517401, 11506.7697697936],
    [0.00000000053, 1.45828359397, 233141.31440436149],
    [0.00000000038, 3.32444534628, 5643.1785636774],
    [0.00000000047, 6.21543665927, 6681.2248533996],
    [0.00000000037, 0.3635930998, 10177.2576795336],
    [0.00000000045, 5.29587706357, 10575.4066829418],
    [0.00000000034, 5.63446915337, 6525.8044539654],
    [0.00000000034, 5.36385158519, 4933.2084403326],
    [0.00000000035, 5.36152295839, 25158.6017197654],
    [0.00000000042, 5.08837645072, 11015.1064773348],
    [0.00000000042, 4.22496037505, 88860.05707098669],
    [0.00000000039, 1.99171699618, 6284.0561710596],
    [0.00000000029, 3.1908862817, 11926.2544136688],
    [0.00000000029, 0.14996158324, 12168.0026965746],
    [0.0000000003, 1.58346276808, 9779.1086761254],
    [0.00000000026, 4.16210340581, 12569.6748183318],
    [0.00000000036, 2.74684637873, 3738.761430108],
    [0.00000000026, 0.7282491532, 1589.0728952838],
    [0.00000000031, 5.34906371821, 143571.32428481648],
    [0.00000000025, 0.10240267494, 22483.84857449259],
    [0.0000000003, 3.47110495524, 14945.3161735544],
    [0.00000000026, 3.89359701125, 5753.3848848968],
    [0.00000000024, 1.18744224678, 4535.0594369244],
    [0.00000000033, 2.99317143244, 3930.2096962196],
    [0.00000000024, 1.57253767584, 6496.3749454294],
    [0.00000000024, 3.47434797542, 4136.9104335162],
    [0.00000000022, 3.91230073719, 6275.9623029906],
    [0.00000000025, 4.02978941287, 3128.3887650958],
    [0.00000000023, 1.07724492065, 12721.572099417],
    [0.00000000021, 1.89591807148, 16730.4636895958],
    [0.00000000025, 2.42198937013, 5729.506447149],
    [0.0000000002, 1.78163489101, 17789.845619785],
    [0.00000000021, 0.49258939822, 29088.811415985],
    [0.00000000026, 4.14947806747, 2388.8940204492],
    [0.00000000027, 2.54785812264, 3496.032826134],
    [0.0000000002, 4.29944129273, 16858.4825329332],
    [0.00000000021, 5.97796936723, 7.1135470008],
    [0.00000000019, 0.80292033311, 16062.1845261168],
    [0.00000000024, 4.89894141052, 17260.1546546904],
    [0.00000000025, 1.37003752175, 6282.0955289232],
    [0.00000000022, 4.92663152168, 18875.525869774],
    [0.00000000023, 5.68902059771, 16460.33352952499],
    [0.00000000023, 3.03021283729, 66567.48586525429],
    [0.00000000016, 3.89713736666, 5331.3574437408],
    [0.00000000016, 5.68562539832, 12559.038152982],
    [0.00000000016, 3.95085099736, 3097.88382272579],
    [0.00000000016, 3.99041783945, 6283.14316029419],
    [0.0000000002, 6.106439191, 167283.76158766549],
    [0.00000000015, 4.09775914607, 11712.9553182308],
    [0.00000000016, 5.717699407, 17298.1823273262],
    [0.00000000016, 3.28894009404, 5884.9268465832],
    [0.00000000015, 4.4256424368, 13517.8701062334],
    [0.00000000016, 4.4345208093, 6283.0085396886],
    [0.00000000014, 1.44384279999, 4164.311989613],
    [0.00000000014, 4.47380919159, 11790.6290886588],
    [0.00000000014, 4.77646531825, 7342.4577801806],
    [0.00000000011, 2.56768522896, 5481.2549188676],
    [0.00000000011, 1.514433322, 16200.7727245012],
    [0.00000000011, 0.88708889185, 21228.3920235458],
    [0.00000000014, 4.50116508534, 640.8776073822],
];

const VSOP87_R3: Vsop87Element = [
    [0.00000144595, 4.27319433901, 6283.0758499914],
    [0.00000006729, 3.91706261708, 12566.1516999828],
    [0.00000000774],
    [0.00000000247, 3.73021571217, 18849.2275499742],
    [0.00000000036, 2.8008140905, 6286.5989683404],
    [0.00000000033, 5.62990083112, 6127.6554505572],
    [0.00000000018, 3.72826142555, 6438.4962494256],
    [0.00000000016, 4.26011484232, 6525.8044539654],
    [0.00000000014, 3.47817116396, 6256.7775301916],
    [0.00000000012, 3.55747379482, 25132.3033999656],
    [0.0000000001, 4.43995693209, 4705.7323075436],
    [0.0000000001, 4.2804525547, 83996.84731811189],
    [0.00000000009, 5.36457057335, 6040.3472460174],
    [0.00000000008, 1.78458957263, 5507.5532386674],
    [0.00000000009, 0.4727519993, 6279.5527316424],
    [0.00000000009, 1.34741231639, 6309.3741697912],
    [0.00000000009, 0.77092900708, 5729.506447149],
    [0.00000000007, 3.50146897332, 7058.5984613154],
    [0.00000000005, 2.890710617, 775.522611324],
    [0.00000000006, 2.36514111314, 6836.6452528338],
];

const VSOP87_R4: Vsop87Element = [
    [0.00000003858, 2.56389016346, 6283.0758499914],
    [0.00000000306, 2.26911740541, 12566.1516999828],
    [0.00000000053, 3.44031471924, 5573.1428014331],
    [0.00000000015, 2.03136359366, 18849.2275499742],
    [0.00000000013, 2.05688873673, 77713.7714681205],
    [0.00000000007, 4.4121885448, 161000.6857376741],
    [0.00000000004, 5.33854414781, 6438.4962494256],
    [0.00000000006, 3.81514213664, 149854.40013480789],
    [0.00000000004, 4.26602478239, 6127.6554505572],
];

const VSOP87_R5: Vsop87Element = [
    [0.00000000086, 1.21805304895, 6283.0758499914],
    [0.00000000012, 0.65572878044, 12566.1516999828],
];

export const VSOP87_X: Vsop87Group = [VSOP87_L0, VSOP87_L1, VSOP87_L2, VSOP87_L3, VSOP87_L4, VSOP87_L5];

export const VSOP87_Y: Vsop87Group = [VSOP87_B0, VSOP87_B1, VSOP87_B2, VSOP87_B3, VSOP87_B4, VSOP87_B5];

export const VSOP87_Z: Vsop87Group = [VSOP87_R0, VSOP87_R1, VSOP87_R2, VSOP87_R3, VSOP87_R4, VSOP87_R5];
